// tr — checkin/quickCheck/stepTracker blocks translated.
export const tr = {
  "common": {
    "loading": "Yükleniyor...",
    "save": "Kaydet",
    "cancel": "İptal",
    "delete": "Sil",
    "edit": "Düzenle",
    "close": "Kapat",
    "confirm": "Onayla",
    "back": "Geri",
    "next": "İleri",
    "submit": "Gönder",
    "search": "Ara",
    "select": "Seç",
    "or": "Veya",
    "and": "ve",
    "note": "Not",
    "viewAll": "Hepsini Gör",
    "learnMore": "Daha Fazla Bilgi",
    "getStarted": "Başlayın",
    "continue": "Devam Et",
    "saving": "Kaydediliyor…"
  },
  "nav": {
    "dashboard": "Ana Sayfa",
    "nutrition": "Beslenme",
    "family": "Aile",
    "care": "Hizmetler",
    "careShort": "Hizmetler",
    "checkIn": "Günlük Takip",
    "insights": "Analizler",
    "trends": "Trendler",
    "habits": "Alışkanlıklar",
    "medications": "İlaçlar",
    "expertSupport": "Uzman Desteği",
    "profile": "Profil",
    "healthHub": "Sağlık Merkezi",
    "support": "Destek",
    "wellness": "Esenlik",
    "education": "Eğitim",
    "community": "Topluluk",
    "preventiveHealth": "Koruyucu Sağlık",
    "womensHealth": "Kadın Sağlığı",
    "reminders": "Sağlık Hatırlatıcıları",
    "meals": "Öğünler",
    "orders": "Siparişler",
    "subscription": "Abonelik",
    "logout": "Çıkış Yap"
  },

  "navShort": {
    "dashboard": "Ana",
    "nutrition": "Beslenme",
    "family": "Aile",
    "care": "Hizmet",
    "support": "Yardım",
    "profile": "Profil"
  },
  "auth": {
    "login": "Giriş Yap",
    "register": "Hesap Oluştur",
    "logout": "Çıkış Yap",
    "email": "E-posta",
    "password": "Şifre",
    "name": "Ad Soyad",
    "forgotPassword": "Şifremi Unuttum?",
    "noAccount": "Hesabınız yok mu?",
    "haveAccount": "Zaten bir hesabınız var mı?",
    "signInHere": "Buradan giriş yapın",
    "signUpHere": "Buradan kayıt olun",
    "welcomeBack": "Tekrar hoş geldiniz!",
    "getStarted": "Hadi başlayalım",
    "biometricLogin": "Biyometrik ile Giriş",
    "biometricHelper": "Parmak izi, Face ID veya Windows Hello kullanın",
    "vendorLogin": "Kurumsal Giriş",
    "createOne": "Bir tane oluşturun",
    "tagline": "Sağlığınızda bir adım önde olun — her gün basit bir kontrolle.",
    "takes30s": "30 saniyeden kısa sürer",
    "emailPlaceholder": "isminiz@ornek.com",
    "passwordPlaceholder": "Şifrenizi girin",
    "checking": "Kontrol ediliyor…",
    "continue": "Devam Et",
    "secureMessage": "Güvenli ve gizli — verileriniz korunur",
    "biometricSoon": "Biyometrik giriş — Çok Yakında",
    "sessionExpired": "Oturumunuzun süresi doldu. Lütfen kaldığınız yerden devam etmek için tekrar giriş yapın.",
    "showPassword": "Şifreyi göster",
    "hidePassword": "Şifreyi gizle",
    "vendor": {
      "title": "Tedarikçi Ortağı Girişi",
      "subtitle": "HealthLoop tedarikçi panelinize erişin",
      "businessEmail": "İş E-postası",
      "emailPlaceholder": "tedarikci@isletme.com",
      "passwordPlaceholder": "••••••••",
      "signingIn": "Giriş yapılıyor...",
      "signIn": "Giriş Yap",
      "notVendorYet": "Henüz tedarikçi ortağımız değil misiniz?",
      "registerBusiness": "İşletmenizi kaydedin",
      "areYouUser": "Kullanıcı mısınız?",
      "userLogin": "Kullanıcı Girişi",
      "welcomeBackToast": "Tekrar hoş geldiniz!",
      "genericError": "Giriş başarısız. Lütfen tekrar deneyin."
    },
    "admin": {
      "backToUserLogin": "Kullanıcı girişi",
      "title": "Yönetici Girişi",
      "restrictedBadge": "Kısıtlı",
      "tagline": "HealthLoop operatör konsolu — yönetici kimlik bilgileri gereklidir.",
      "emailLabel": "Yönetici e-postası",
      "emailPlaceholder": "yonetici@alanadiniz.com",
      "passwordLabel": "Şifre",
      "passwordPlaceholder": "Yönetici şifrenizi girin",
      "signingIn": "Giriş yapılıyor…",
      "submit": "Yönetici konsoluna giriş yap",
      "secureNote": "Güvenli bağlantı · oturum şifrelendi",
      "restrictedTitle": "Bu alan yöneticilere özeldir.",
      "restrictedBody": "Hesabınızla giriş yapılmış ancak yönetici erişim yetkiniz bulunmuyor. Farklı bir hesapla denemek için çıkış yapın veya ana uygulamaya dönün.",
      "signOut": "Çıkış yap",
      "backToApp": "Uygulamaya dön"
    }
  },
  "quickCheck": {
    "header": {
      "title": "Bugün nasıl hissediyorsun?",
      "subtitle": "Hızlı kontrol — 60 saniyeden kısa sürer"
    },
    "section1": {
      "title": "Bugün neler fark ediyorsun?",
      "hint": "(Geçerli olanların tümünü seç)"
    },
    "environment": {
      "title": "Bugünkü çevren",
      "hint": "Bulunduğun ortamı anlamamıza yardımcı ol"
    },
    "basicChecks": {
      "title": "Hızlı temel kontroller",
      "hint": "İsteğe bağlı ama faydalı"
    },
    "validation": {
      "pickOne": "Lütfen en az bir soruyu yanıtla"
    },
    "submit": {
      "cta": "Sağlık Bilgimi Al",
      "saving": "Kaydediliyor...",
      "analyzing": "Sağlık verilerin analiz ediliyor...",
      "savedToast": "✅ Kaydedildi! Sağlık verilerin analiz ediliyor..."
    }
  },
  "stepTracker": {
    "header": {
      "title": "Adım Takibi",
      "subtitle": "Güvenilir ve kolay aktivite takibi",
      "backToDashboard": "Panele dön"
    },
    "today": {
      "title": "Bugünkü adımlar",
      "goalProgress": "{{current}} / {{goal}} adım",
      "goalReached": "Hedefe ulaşıldı — harika iş!",
      "keepGoing": "Devam et — harika gidiyorsun."
    },
    "streak": {
      "label": "Güncel seri",
      "days": "{{count}} gün",
      "daysPlural": "{{count}} gün"
    },
    "badges": {
      "title": "Rozetler",
      "empty": "Alışkanlık kazandıkça rozetler kazanacaksın."
    },
    "reminders": {
      "title": "Hareket hatırlatıcıları",
      "hint": "Uzun süre oturduğunda kısa bir yürüyüş için nazik hatırlatmalar.",
      "enabled": "Açık",
      "disabled": "Kapalı"
    },
    "insights": {
      "weeklyAverage": "Haftalık ortalama",
      "weeklyGoal": "Haftalık hedef"
    },
    "actions": {
      "connect": "Bir adım kaynağı bağla",
      "manualLog": "Adımları manuel gir",
      "changeGoal": "Günlük hedefi değiştir"
    }
  },
  "checkin": {
    "header": {
      "title": "Günlük Sağlık Kontrolü",
      "subtitle": "60 saniyeden kısa sürer",
      "restDayLink": "Bugün pek havamda değilim"
    },
    "snapshot": {
      "title": "Panelin güncellendi",
      "healthScore": "Sağlık puanı",
      "todayTasks": "Bugünün görevleri",
      "dayStreak": "günlük seri"
    },
    "resume": {
      "banner": "Kaldığın yerden devam et",
      "startFresh": "Yeniden başla",
      "dismiss": "Kapat"
    },
    "progress": {
      "allSet": "Hepsi tamam",
      "step": "Adım {{current}} / {{total}}",
      "ariaLabel": "Günlük kontrol ilerlemesi: {{total}} bölümden {{done}} tanesi tamamlandı"
    },
    "insights": {
      "title": "Sağlık Bilgilerin",
      "subtitle": "Bugün senin için kişiselleştirildi",
      "insightForYou": "Sana özel ipucu",
      "simpleActions": "Atabileceğin basit adımlar",
      "whenToSeekHelp": "Ne zaman destek almalı?",
      "nhsAdvice": "Endişelenirseniz, aile hekiminize veya bir sağlık kuruluşuna danışın",
      "backToDashboard": "Panele Dön",
      "newCheckIn": "Yeni Kayıt",
      "disclaimer": "HealthLoop tıbbi teşhis değil, sağlıklı yaşam rehberliği sunar."
    },
    "restDay": {
      "title": "Dinlenmek de yaşamın bir parçası.",
      "body": "Sen hazır olduğunda, biz yarın burada olacağız.",
      "streakNote": "Serin bozulmadı — o da seninle birlikte dinleniyor.",
      "backToDashboard": "Panele dön",
      "changedMind": "Aslında, yine de bir göz atmak isterim."
    },
    "feelings": {
      "title": "Bugün nasıl hissediyorsun?",
      "hint": "Geçerli olanların tümünü seç",
      "tired": "Yorgun hissediyorum",
      "headache": "Baş ağrısı",
      "stressed": "Stresli veya bunalmış",
      "pain": "Vücut veya eklem ağrısı",
      "okay": "Bugün iyi hissediyorum"
    },
    "basics": {
      "title": "Temel ihtiyaçların",
      "sleepQ": "Dün gece iyi uyuyabildin mi?",
      "waterQ": "Bugün yeterince su içtin mi?",
      "foodQ": "Bugün düzenli beslenebildin mi?",
      "activityQ": "Bugün ne kadar aktiftin?",
      "yes": "Evet",
      "notReally": "Pek sayılmaz",
      "notYet": "Henüz değil",
      "notActive": "Aktif değildim",
      "lightActivity": "Hafif aktivite",
      "active": "Aktiftim"
    },
    "mind": {
      "title": "Zihin ve enerji",
      "stressQ": "Bugün stres seviyen nasıl?",
      "moodQ": "Bugün modun nasıl?",
      "energyQ": "Bugün enerji seviyen nasıl?",
      "low": "Düşük",
      "moderate": "Orta",
      "high": "Yüksek",
      "neutral": "Nötr",
      "good": "İyi",
      "okay": "Fena değil"
    },
    "day": {
      "title": "Günün",
      "routineQ": "Bugün normal rutinine sadık kalabildin mi?",
      "yes": "Evet",
      "no": "Hayır"
    },
    "environment": {
      "title": "Bugünkü çevren",
      "describeQ": "Bulunduğun ortamı nasıl tarif edersin?",
      "comfortable": "😊 Rahat",
      "slightlyUncomfortable": "😐 Biraz rahatsız",
      "challenging": "😓 Zorlayıcı",
      "affectedQ": "Çevren nasıl hissettiğini etkiledi mi?",
      "yes": "Evet",
      "no": "Hayır",
      "exposureLabel": "Maruz kalınan durumlar (tümünü seç)",
      "heat": "🌡️ Sıcak",
      "cold": "❄️ Soğuk",
      "noise": "🔊 Gürültü",
      "dustSmoke": "💨 Toz veya duman",
      "crowded": "👥 Kalabalık ortam",
      "none": "✅ Hiçbiri"
    },
    "submit": {
      "analyzing": "Sağlık verilerin analiz ediliyor...",
      "cta": "Sağlık Bilgilerimi Gör"
    },
    "toast": {
      "savedFull": "Kaydedildi! Panelin güncellendi.",
      "savedShort": "Kayıt başarıyla kaydedildi."
    }
  },
  "onboarding": {
    "welcome": "Hoş Geldiniz",
    "completeSetup": "Kurulumu Tamamla",
    "stepProgress": "Adım {{step}} / {{total}}",
    "percentComplete": "%{{percent}} tamamlandı",
    "welcomeToast": "HealthLoop'a hoş geldiniz! Profiliniz oluşturuldu.",
    "errorAgeRange": "Lütfen yaş aralığınızı seçin",
    "errorCountry": "Lütfen ülkenizi seçin",
    "errorGoal": "Lütfen birincil sağlık hedefinizi seçin",
    "errorCuisine": "Lütfen en az bir mutfak tercihi seçin",
    "errorGeneric": "Kayıt işlemi tamamlanamadı. Lütfen tekrar deneyin.",
    "step1Title": "HealthLoop'a Hoş Geldiniz! 👋",
    "step1Subtitle": "Sağlık yolculuğunuzu kişiselleştirelim",
    "ageRangeLabel": "Yaş aralığınız nedir?",
    "genderLabel": "Cinsiyet (İsteğe bağlı)",
    "gender_male": "Erkek",
    "gender_female": "Kadın",
    "gender_non-binary": "İksiz (Non-binary)",
    "gender_prefer_not_to_say": "Belirtmek istemiyorum",
    "step2Title": "Nerede yaşıyorsunuz? 🌍",
    "step2Subtitle": "Bu, kültürel olarak uygun yemekler önermemize yardımcı olur",
    "countryLabel": "Ülkenizi seçin",
    "country_uk": "Birleşik Krallık",
    "country_nigeria": "Nijerya",
    "country_ghana": "Gana",
    "country_kenya": "Kenya",
    "country_south_africa": "Güney Afrika",
    "country_usa": "Amerika Birleşik Devletleri",
    "country_canada": "Kanada",
    "country_india": "Hindistan",
    "country_jamaica": "Jamaika",
    "country_other": "Diğer",
    "step3Title": "Ana hedefiniz nedir? 🎯",
    "step3Subtitle": "Birincil sağlık hedefinizi seçin",
    "additionalGoals": "Başka bir hedefiniz var mı? (İsteğe bağlı)",
    "goal_weight_loss": "Kilo Vermek",
    "goalDesc_weight_loss": "Sağlıklı bir şekilde kilo verin",
    "goal_weight_maintenance": "Kiloyu Korumak",
    "goalDesc_weight_maintenance": "Mevcut kilonuzda kalın",
    "goal_muscle_gain": "Kas Yapmak",
    "goalDesc_muscle_gain": "Güç ve kas kazanın",
    "goal_general_wellness": "Genel Esenlik",
    "goalDesc_general_wellness": "Genel sağlığı iyileştirme",
    "goal_better_sleep": "Daha İyi Uyku",
    "goalDesc_better_sleep": "Uyku kalitesini artırın",
    "goal_reduce_stress": "Stresi Azaltmak",
    "goalDesc_reduce_stress": "Stresi daha iyi yönetin",
    "goal_increase_energy": "Daha Fazla Enerji",
    "goalDesc_increase_energy": "Daha enerjik hissedin",
    "step4Title": "Yemek tercihleri 🍽️",
    "step4Subtitle": "Sevdiğiniz mutfakları ve beslenme kısıtlamalarınızı seçin",
    "cuisineLabel": "Tercih Edilen Mutfaklar",
    "cuisineHint": "En az bir tane seçin (birden fazla seçebilirsiniz)",
    "dietaryLabel": "Beslenme Kısıtlamaları (İsteğe bağlı)",
    "diet_vegetarian": "Vejetaryen",
    "diet_vegan": "Vegan",
    "diet_halal": "Helal",
    "diet_kosher": "Koşer",
    "diet_gluten_free": "Glutensiz",
    "diet_dairy_free": "Sütsüz",
    "diet_pescatarian": "Pesketaryen",
    "step5Title": "Sağlık durumları 🏥",
    "step5Subtitle": "İsteğe bağlı — daha iyi öneriler sunmamıza yardımcı olur",
    "conditionsLabel": "Bu durumlardan herhangi birine sahip misiniz?",
    "conditionsHint": "Bu bilgiler gizlidir ve deneyiminizi kişiselleştirmeye yardımcı olur",
    "condition_diabetes": "Diyabet",
    "condition_hypertension": "Yüksek Tansiyon",
    "condition_heart_disease": "Kalp Hastalığı",
    "condition_thyroid": "Tiroid Sorunları",
    "condition_celiac": "Çölyak Hastalığı",
    "condition_ibs": "Huzursuz Bağırsak Sendromu (IBS)",
    "condition_none": "Hiçbiri",
    "privacyTitle": "Verileriniz koruma altında",
    "privacyBody": "Kişisel bilgileriniz şifrelenir ve güvenle saklanır. Bu verileri yalnızca size özel yemek önerileri, sağlık ipuçları ve bildirimler sunarak deneyiminizi kişiselleştirmek için kullanırız. Verileriniz, açık rızanız olmadan asla üçüncü taraflarla paylaşılmaz.",
    "trackMedication": "İlaçlarımı takip etmek istiyorum",
    "specialistInterest": "Uzman konsültasyonları ile ilgileniyorum",
    "welcomeTitle": "HealthLoop'a Hoş Geldiniz! 👋",
    "welcomeSubtitle": "Yapay zeka destekli önleyici sağlık ve yaşam tarzı zekanızı birkaç basit adımda kişiselleştirelim",
    "stepLabel": "Adım {{current}} / {{total}}",
    "skipForNow": "Şimdilik atla",
    "skipToast": "Profilinizden dilediğiniz zaman kurulumu tamamlayabilirsiniz",
    "back": "Geri",
    "next": "İleri",
    "completing": "Tamamlanıyor...",
    "complete": "Kurulumu Bitir",
    "successToast": "HealthLoop'a hoş geldiniz! Profiliniz artık kişiselleştirildi 🎉",
    "failureToast": "Kurulum tamamlanamadı",
    "validation": {
      "basicInfo": "Lütfen tüm temel bilgileri doldurun",
      "pickGoal": "Lütfen en az bir sağlık hedefi seçin",
      "pickPrimary": "Lütfen ana hedefinizi seçin",
      "pickRegion": "Kişiselleştirilmiş yemek önerileri için lütfen kültürel bölgenizi seçin",
      "pickFocus": "Lütfen ana esenlik odağınızı seçin"
    },
    "step1": {
      "title": "Sağlık Profiliniz",
      "description": "Size özel yapay zeka sağlık zekasını oluşturmamıza yardımcı olun",
      "age": "Yaş *",
      "agePlaceholder": "örneğin, 30",
      "height": "Boy (cm) *",
      "heightPlaceholder": "örneğin, 170",
      "weight": "Kilo (kg) *",
      "weightPlaceholder": "örneğin, 70"
    },
    "step2": {
      "title": "Sağlık Hedefleriniz",
      "description": "Size uyanların tümünü işaretleyin ve ardından ana hedefinizi belirleyin",
      "primaryLabel": "Ana Hedefinizi Seçin *",
      "primaryBadge": "Ana Hedef"
    },
    "step3": {
      "title": "🌍 Kültürel ve Yemek Tercihleri",
      "description": "Yemek önerilerinizi kişiselleştirmemize yardımcı olun",
      "regionLabel": "Kültürel Bölge *",
      "regionHint": "Kişiselleştirilmiş yemek önerileri için kültürel geçmişinizi seçin",
      "countryLabel": "Ülke (İsteğe bağlı)",
      "countryPlaceholder": "örneğin, Türkiye, Nijerya, Jamaika",
      "countryHint": "Daha da isabetli öneriler alabilmeniz için",
      "foodPrefLabel": "Yemek Çeşitliliği Tercihi"
    },
    "step4": {
      "title": "Ana Esenlik Odağı",
      "description": "En çok odaklanmak istediğiniz alanı seçin"
    },
    "step5": {
      "title": "Tercihleriniz",
      "description": "HealthLoop deneyiminizi kendinize göre şekillendirin",
      "trackMeds": "İlaç Takibi Yap",
      "trackMedsHint": "Günlük kontrollerinizde ilaç takibini ve hatırlatıcıları etkinleştirin",
      "specialist": "Uzman Desteği ile İlgileniyorum",
      "specialistHint": "Esenlik uzmanları, beslenme uzmanları ve ruh sağlığı profesyonellerine erişim sağlayın",
      "confidentialTitle": "Güvenli Destek:",
      "confidentialBody": "Tüm bilgileriniz korunmaktadır ve yalnızca size özel önleyici sağlık analizleri sunmak amacıyla kullanılır."
    },
    "step6": {
      "title": "Yemek Kişiselleştirme",
      "description": "Damak tadınıza ve beslenme ihtiyaçlarınıza uygun yemekler önermemize yardımcı olun",
      "cuisinesLabel": "Tercih Edilen Mutfaklar (İsteğe bağlı)",
      "cuisinesHint": "En sevdiğiniz mutfakları seçin",
      "dietaryLabel": "Beslenme Kısıtlamaları (İsteğe bağlı)",
      "dietaryHint": "Sizin için geçerli olanları seçin",
      "allergiesLabel": "Yaygın Alerjiler (İsteğe bağlı)",
      "allergiesHint": "Varsa gıda alerjilerinizi seçin",
      "personalisedTitle": "Kişiselleştirilmiş Öğünler:",
      "personalisedBody": "Bu tercihleri, tadı ve besin değerleri size en uygun yemekleri önermek için kullanacağız. Bunları dilediğiniz zaman Ayarlar'dan güncelleyebilirsiniz."
    },
    "healthGoals": {
      "better_sleep": "Daha İyi Uyku",
      "reduce_stress": "Stresi Azaltmak",
      "increase_energy": "Enerjiyi Artırmak",
      "weight_management": "Kilo Yönetimi",
      "improve_fitness": "Zindelik Kazanmak",
      "better_nutrition": "Daha İyi Beslenmek",
      "mental_wellness": "Zihinsel Esenlik",
      "chronic_condition": "Kronik Durum Yönetimi"
    },
    "wellnessFocus": {
      "mental_health": {
        "label": "Ruh Sağlığı",
        "description": "Ruh hali, stres ve duygusal sağlığa odaklanın"
      },
      "physical_fitness": {
        "label": "Fiziksel Zindelik",
        "description": "Egzersiz, güç ve hareketliliğe odaklanın"
      },
      "nutrition": {
        "label": "Beslenme",
        "description": "Diyet, öğünler ve sağlıklı beslenmeye odaklanın"
      },
      "sleep": {
        "label": "Uyku Kalitesi",
        "description": "Dinlenme, uyku düzeni ve toparlanmaya odaklanın"
      },
      "stress_management": {
        "label": "Stres Yönetimi",
        "description": "Rahatlama ve stres azaltmaya odaklanın"
      }
    },
    "culturalRegions": {
      "west_african": {
        "label": "Batı Afrika",
        "description": "Nijerya, Gana, Senegal mutfağı"
      },
      "east_african": {
        "label": "Doğu Afrika",
        "description": "Kenya, Etiyopya, Tanzanya mutfağı"
      },
      "north_african": {
        "label": "Kuzey Afrika",
        "description": "Fas, Mısır mutfağı"
      },
      "southern_african": {
        "label": "Güney Afrika",
        "description": "Güney Afrika mutfağı"
      },
      "caribbean": {
        "label": "Karayipler",
        "description": "Jamaika, Trinidad, Barbados mutfağı"
      },
      "middle_eastern": {
        "label": "Orta Doğu",
        "description": "Lübnan, Filistin, Suriye mutfağı"
      },
      "south_asian": {
        "label": "Güney Asya",
        "description": "Hindistan, Pakistan, Bangladeş mutfağı"
      },
      "east_asian": {
        "label": "Doğu Asya",
        "description": "Çin, Japon, Kore mutfağı"
      },
      "southeast_asian": {
        "label": "Güneydoğu Asya",
        "description": "Tayland, Vietnam, Endonezya mutfağı"
      },
      "western": {
        "label": "Batı",
        "description": "Amerikan, Avrupa mutfağı"
      },
      "latin_american": {
        "label": "Latin Amerika",
        "description": "Meksika, Brezilya, Arjantin mutfağı"
      },
      "mediterranean": {
        "label": "Akdeniz",
        "description": "Yunan, İtalyan, İspanyol mutfağı"
      }
    },
    "foodPreferences": {
      "traditional": {
        "label": "Geleneksel",
        "description": "Ağırlıklı olarak kendi kültürel bölgenizden yemekler"
      },
      "mixed": {
        "label": "Karışık",
        "description": "Yerel ve uluslararası mutfak dengesi"
      },
      "international": {
        "label": "Uluslararası",
        "description": "Dünya mutfaklarından çeşitli lezzetler"
      }
    },
    "cuisines": {
      "west_african": "Batı Afrika",
      "caribbean": "Karayipler",
      "mediterranean": "Akdeniz",
      "asian": "Asya",
      "western": "Batı",
      "indian": "Hint",
      "middle_eastern": "Orta Doğu",
      "general": "Tüm Mutfaklar"
    },
    "dietary": {
      "vegetarian": "Vejetaryen",
      "vegan": "Vegan",
      "pescatarian": "Pesketaryen",
      "gluten_free": "Glutensiz",
      "dairy_free": "Sütsüz",
      "low_carb": "Düşük Karbonhidrat"
    },
    "allergies": {
      "nuts": "Kuruyemiş",
      "shellfish": "Kabuklu Deniz Ürünleri",
      "dairy": "Süt Ürünleri",
      "eggs": "Yumurta",
      "soy": "Soya",
      "gluten": "Gluten"
    },
    "cuisine_nigerian": "Nijerya",
    "cuisine_ghanaian": "Gana",
    "cuisine_senegalese": "Senegal",
    "cuisine_kenyan": "Kenya",
    "cuisine_ethiopian": "Etiyopya",
    "cuisine_moroccan": "Fas",
    "cuisine_south_african": "Güney Afrika",
    "cuisine_jamaican": "Jamaika",
    "cuisine_trinidadian": "Trinidad",
    "cuisine_lebanese": "Lübnan",
    "cuisine_turkish": "Türk",
    "cuisine_greek": "Yunan",
    "cuisine_italian": "İtalyan",
    "cuisine_french": "Fransız",
    "cuisine_british": "İngiliz",
    "cuisine_indian_south": "Güney Hindistan",
    "cuisine_indian_north": "Kuzey Hindistan",
    "cuisine_pakistani": "Pakistan",
    "cuisine_japanese": "Japon",
    "cuisine_chinese": "Çin",
    "cuisine_korean": "Kore",
    "cuisine_vietnamese": "Vietnam",
    "cuisine_thai": "Tayland",
    "cuisine_filipino": "Filipin",
    "cuisine_american": "Amerikan",
    "cuisine_mexican": "Meksika",
    "cuisine_brazilian": "Brezilya",
    "cuisine_peruvian": "Peru"
  },
  "dashboard": {
    "welcome": "Tekrar hoş geldiniz",
    "greeting": "Merhaba",
    "goodMorning": "Günaydın",
    "goodAfternoon": "Tünaydın",
    "goodEvening": "İyi Akşamlar",
    "tagline": "Küçük sağlıklı adımlar kalıcı değişim yaratır",
    "microcopy": "Sağlık yolculuğunuz değerlidir.",
    "welcomeSubtitleMorning1": "Güne sakin bir başlangıç.",
    "welcomeSubtitleMorning2": "Bu sabah uğradığınıza sevindik.",
    "welcomeSubtitleMorning3": "Küçük anlar birikir.",
    "welcomeSubtitleAfternoon1": "Umarız gününüz dengeli geçiyordur.",
    "welcomeSubtitleAfternoon2": "HealthLoop'a tekrar hoş geldiniz.",
    "welcomeSubtitleAfternoon3": "Bir nefes alın — iyi gidiyorsunuz.",
    "welcomeSubtitleEvening1": "Günü sizinle birlikte bitiriyoruz.",
    "welcomeSubtitleEvening2": "Güne nazik bir veda.",
    "welcomeSubtitleEvening3": "Bu akşam tekrar hoş geldiniz.",
    "title": "Koruyucu Sağlık İstihbarat Platformunuz",
    "subtitle": "Sorunlar büyümeden takip edin, öğrenin ve harekete geçin",
    "summary": "Sağlık İstihbaratı Özeti",
    "summaryDesc": "Önleme, eğitim, etkileşim ve esenlik alanlarında gerçek zamanlı analizler",
    "comprehensiveSupport": "Önleme, eğitim, etkileşim ve esenlikte kapsamlı destek",
    "todayCheckIn": "Bugünkü Takip",
    "quickActions": "Hızlı İşlemler",
    "healthOverview": "Sağlık Genel Bakışı",
    "recentActivity": "Son Etkinlikler",
    "viewAll": "Hepsini Gör",
    "preventiveHealth": "Koruyucu Sağlık",
    "preventiveHealthDesc": "Günlük takip, esenlik izleme ve koruyucu uyarılar",
    "education": "Eğitim",
    "educationDesc": "Kanıta dayalı bilgiler, sağlık makaleleri ve uzman rehberliği",
    "engagement": "Etkileşim",
    "engagementDesc": "Topluluk yarışmaları, alışkanlık takibi ve sosyal destek",
    "wellness": "Esenlik",
    "wellnessDesc": "Akıllı beslenme, yaşam tarzı dengesi ve bütünsel sağlık",
    "todaysInsight": "Günün Analizi",
    "wellnessScore": "Esenlik Puanı",
    "healthStreak": "Sağlık Serisi",
    "days": "gün",
    "logHealth": "Sağlık Kaydı",
    "getEducated": "Bilgilenin",
    "communityChallenge": "Topluluk Yarışması",
    "checkWellness": "Esenliği Kontrol Et",
    "verified": "Doğrulanmış",
    "joinCommunity": "Topluluğa Katıl",
    "personalizedPlan": "Kişiselleştirilmiş Plan",
    "score": "Puan",
    "checkIns": "kayıtlar",
    "habits": "alışkanlıklar",
    "preventive": "Koruyucu",
    "healthMetrics": "Sağlık Ölçümleri",
    "trackMetrics": "Ölçümleri Takip Et",
    "startTracking": "Takibe başla",
    "logMetrics": "Ölçümleri Kaydet",
    "dailyInsight": "Günlük Bilgi",
    "learnAbout": "Bugün koruyucu sağlık hakkında bilgi edinin",
    "articlesAvailable": "makale mevcut",
    "browseArticles": "Makalelere Göz At",
    "currentStreak": "Mevcut Seri",
    "keepGoing": "Böyle devam edin!",
    "startStreak": "Serinizi başlatın",
    "checkIn": "Kontrol Et",
    "nutritionPlan": "Beslenme Planı",
    "mealsPlanned": "planlanan öğün",
    "viewPlan": "Planı Görüntüle",
    "planYourWeek": "Haftanızı planlayın",
    "moodStress": "Ruh Hali ve Stres",
    "howFeeling": "Nasıl hissediyorsunuz?",
    "logWellness": "Esenlik Kaydı Yap",
    "medications": "İlaçlar",
    "noMeds": "Takip edilen ilaç yok",
    "addMedications": "İlaçlarınızı ekleyin",
    "daysTracked": "Takip Edilen Gün",
    "noHabits": "Henüz alışkanlık yok",
    "startTrackingHabits": "Alışkanlıkları takip etmeye başlayın",
    "insights": "Analizler",
    "noInsights": "Henüz analiz yok",
    "completeFirstPlan": "İlk planınızı tamamlayın",
    "noCheckIns": "Henüz kayıt yok",
    "startFirstCheckIn": "İlk kontrolünüzü yapın"
  },
  "support": {
    "title": "Destek",
    "subtitle": "Yanıtları bulun, bizimle iletişime geçin veya bir sorun bildirin",
    "backToSettings": "Ayarlara geri dön",
    "privacyBanner": "Destek talepleri gizli ve güvenli bir şekilde işlenir. Sağlık bilgileriniz gizli kalır.",
    "section1": "Bölüm 1",
    "section2": "Bölüm 2",
    "section3": "Bölüm 3",
    "section4": "Bölüm 4",
    "navHelpCenter": "Yardım Merkezi",
    "navContact": "Destekle İletişime Geç",
    "navHealth": "Sağlık Hizmetleri",
    "navTechnical": "Teknik Destek",
    "helpCenterTitle": "Yardım Merkezi",
    "helpCenterSubtitle": "Sıkça sorulan soruları arayın ve hızlı yanıtlar bulun.",
    "contactTitle": "Destekle İletişime Geç",
    "contactSubtitle": "Ekibimize tercih ettiğiniz kanal üzerinden ulaşın.",
    "healthServicesTitle": "Sağlık Hizmetleri",
    "healthServicesSubtitle": "İlaç takibi ve klinik uzmanlarla bağlantı kurun.",
    "technicalTitle": "Teknik Destek",
    "technicalSubtitle": "Hataları veya teknik sorunları detaylı bağlamla bildirin.",
    "searchPlaceholder": "Sıkça sorulan sorularda ara…",
    "liveChat": "Canlı Sohbet",
    "emailUs": "Bize E-posta Gönderin",
    "callBack": "Geri arama planla",
    "sendMessage": "Mesaj gönder",
    "medicationTracking": "İlaç takibi",
    "specialistAccess": "Uzman erişimi",
    "videoConsultation": "Görüntülü görüşme",
    "reportBug": "Hata bildir",
    "yourName": "Adınız",
    "yourEmail": "E-postanız",
    "subject": "Konu",
    "message": "Mesaj",
    "phone": "Telefon",
    "description": "Açıklama",
    "submit": "Gönder",
    "successTitle": "Mesaj gönderildi",
    "successDescription": "24–48 saat içinde yanıt vereceğiz.",
    "healthDisclaimer": "Tıbbi acil durumlar için yerel acil servislerle iletişime geçin. HealthLoop, profesyonel tıbbi bakımın yerini tutmaz."
  },
  "nutrition": {
    "smartNutrition": "Akıllı Beslenme",
    "basedOnGoal": "Hedefinize göre:",
    "personalizedData": "Güncel sağlık verilerinize göre kişiselleştirildi",
    "evidenceBased": "Koruyucu sağlık planınızın bir parçası olarak kanıta dayalı beslenme",
    "todaysMealSuggestions": "Bugünün Yemek Önerileri",
    "customize": "Özelleştir",
    "breakfast": "Kahvaltı",
    "lunch": "Öğle Yemeği",
    "dinner": "Akşam Yemeği",
    "loadingBreakfast": "Kahvaltı yükleniyor...",
    "loadingLunch": "Öğle yemeği yükleniyor...",
    "loadingDinner": "Akşam yemeği yükleniyor...",
    "cal": "kcal",
    "protein": "protein",
    "swapMeal": "Yemeği Değiştir",
    "healthyOptionsNearYou": "Yakınınızdaki Sağlıklı Seçenekler",
    "enableLocation": "Konumu etkinleştir",
    "view": "Görüntüle",
    "discoverOptions": "Yakınınızdaki sağlıklı restoranları, marketleri ve yemek hazırlama hizmetlerini keşfedin",
    "cuisinesSelected": "mutfak seçildi",
    "cuisineSelected": "mutfak seçildi",
    "dietaryPrefs": "beslenme tercihi",
    "dietaryPref": "beslenme tercihi",
    "customizeMeals": "Öğünleri Özelleştir",
    "subtitleAdaptive": "Sağlık hedefleriniz için kültürel olarak uyarlanmış, kişiselleştirilmiş öğün planlama",
    "hideFavorites": "Favorileri Gizle",
    "viewFavorites": "Favorileri Görüntüle",
    "customizeMealsLegacy": "Öğünleri kültürel tercihlerinize ve beslenme ihtiyaçlarınıza göre özelleştirin",
    "viewFullPlan": "Tüm Planı Görüntüle",
    "exploreRecipes": "Tarifleri Keşfet"
  },
  "location": {
    "permissionTitle": "Yakınınızdaki sağlıklı seçenekleri bulun",
    "permissionDesc": "Sağlık hedeflerinizle uyumlu restoran, market ve yemek hazırlama hizmetlerini önermek için kullanılır.",
    "howToEnable": "Nasıl etkinleştirilir:",
    "step1": "Tarayıcınızın adres çubuğundaki kilit simgesine 🔒 tıklayın",
    "step2": "\"Konum\" izinlerini bulun",
    "step3": "\"İzin Ver\" olarak değiştirin",
    "step4": "Bu sayfayı yenileyin",
    "refreshPage": "Sayfayı Yenile",
    "allowLocation": "Konuma İzin Ver",
    "notNow": "Şimdi değil",
    "denied": "Konum erişimi engellendi. Yakındaki sağlıklı seçenekleri görmek için konum izinlerini etkinleştirmeniz gerekir.",
    "unavailable": "Konum bilgisi şu anda mevcut değil. Lütfen cihaz ayarlarınızı kontrol edin.",
    "error": "Konumunuza erişilemiyor. Lütfen tekrar deneyin veya tarayıcı ayarlarını kontrol edin.",
    "unsupported": "Tarayıcınız konum servislerini desteklemiyor. Chrome, Firefox veya Safari gibi modern bir tarayıcı kullanmayı deneyin.",
    "accessRequired": "Konum Erişimi Gerekli"
  },
  "womensHealth": {
    "title": "Kadın Sağlığı",
    "description": "Döngünüzü takip edin, semptomları kaydedin ve döngü evrenize göre kişiselleştirilmiş sağlıklı yaşam ipuçları alın",
    "cycleTracking": "Döngü Takibi",
    "symptomLogging": "Semptom Kaydı",
    "phaseInsights": "Evre Analizleri",
    "logPeriod": "Regl Kaydet",
    "logSymptoms": "Semptom Kaydet",
    "insights": "Analizler",
    "tips": "Sağlık İpuçları",
    "overview": "Genel Bakış",
    "history": "Geçmiş",
    "startTracking": "Döngünüzü Takip Etmeye Başlayın"
  },
  "profile": {
    "title": "Profil",
    "personalInfo": "Kişisel Bilgiler",
    "healthProfile": "Sağlık Profili",
    "preferences": "Tercihler",
    "language": "Dil",
    "selectLanguage": "Dil Seçin",
    "notifications": "Bildirimler",
    "privacy": "Gizlilik",
    "security": "Güvenlik",
    "quickAccess": "Hızlı Erişim",
    "editProfile": "Profili Düzenle",
    "viewStats": "İstatistikleri Gör",
    "backToDashboard": "Panele Geri Dön",
    "womensHealthTitle": "Kadın Sağlığı",
    "womensHealthDesc": "Döngü takibi, semptomlar ve sağlık ipuçları",
    "healthRemindersTitle": "Sağlık Hatırlatıcıları",
    "healthRemindersDesc": "Bildirimlerinizi yönetin",
    "manageRemindersDesc": "Hatırlatıcı tercihlerinizi ve bildirimlerinizi yönetin",
    "healthPatternAlerts": "Sağlık Düzeni Uyarılarınız",
    "supportHelp": "Destek ve Yardım",
    "supportHelpDesc": "Yardım alın, sorun bildirin veya SSS'lere göz atın",
    "admin": "Yönetici",
    "adminDesc": "Kullanım metriklerini ve kullanıcı davranışı analizlerini görüntüleyin",
    "giveFeedback": "Geri Bildirim Ver",
    "giveFeedbackDesc": "HealthLoop deneyiminizi paylaşın",
    "reportProblem": "Sorun Bildir",
    "reportProblemDesc": "Hataları düzeltmemize ve uygulamayı geliştirmemize yardımcı olun",
    "manageHealthInfo": "Kişiselleştirilmiş analizler için koruyucu sağlık bilgilerinizi yönetin",
    "basicInformation": "Temel Bilgiler",
    "fullName": "Ad Soyad",
    "email": "E-posta",
    "dateOfBirth": "Doğum Tarihi",
    "gender": "Cinsiyet",
    "height": "Boy (cm)",
    "weight": "Kilo (kg)",
    "medicalConditions": "Tıbbi Durumlar",
    "allergies": "Alerjiler",
    "personalHealth": "Kişisel Sağlık",
    "addCondition": "Tıbbi durum ekle",
    "addAllergy": "Alerji ekle",
    "saveChanges": "Değişiklikleri Kaydet",
    "saving": "Kaydediliyor...",
    "privacyMessage": "Sağlık verileriniz gizli bakım standartlarıyla korunmaktadır"
  },
  "settings": {
    "title": "Ayarlar",
    "general": "Genel",
    "account": "Hesap",
    "appearance": "Görünüm",
    "languageSettings": "Dil Ayarları",
    "changeLanguage": "Dili Değiştir",
    "languageNote": "Arayüz, yeni bir dil seçtiğiniz an güncellenir. Afrika dilleri ve yeni eklenen diller 'Başlangıç' olarak işaretlenmiştir — geniş kapsam sağlamak adına makine çevirisi kullanılmıştır ve ana dil konuşmacısı onayı beklenmektedir.",
    "languageUpdated": "Dil başarıyla güncellendi",
    "starterBadge": "Başlangıç",
    "starterBadgeTooltip": "Makine çevirisi — ana dil konuşmacısı incelemesi bekleniyor.",
    "regions": {
      "global": "Küresel",
      "european": "Avrupa Dilleri",
      "middleEastern": "Orta Doğu Dilleri",
      "asian": "Asya Dilleri",
      "african": "Afrika Dilleri"
    }
  },
  "search": {
    "triggerLabel": "HealthLoop'ta Ara",
    "triggerHint": "\"Adım\", \"eczane\" veya \"gebelik\" yazmayı deneyin",
    "triggerAriaLabel": "Genel aramayı aç",
    "placeholder": "Özellik, takipçi veya destek ara…",
    "inputAriaLabel": "HealthLoop özelliklerinde ara",
    "modalAriaLabel": "HealthLoop'ta Ara",
    "close": "Kapat",
    "clear": "Temizle",
    "clearAriaLabel": "Aramayı temizle",
    "recentSearches": "Son aramalar",
    "tryFor": "Şunları aramayı deneyin:",
    "findFeatures": "İstediğiniz özelliği saniyeler içinde bulun.",
    "searchAcross": "Şu bölümlerde ara:",
    "and": "ve",
    "sections": {
      "home": "Ana Sayfa",
      "nutrition": "Beslenme",
      "family": "Aile",
      "services": "Hizmetler",
      "support": "Destek",
      "profile": "Profil"
    },
    "noMatchesFor": "\"{{query}}\" için sonuç bulunamadı",
    "trySimpler": "Adım, beslenme veya uzman gibi daha basit kelimeler deneyin.",
    "comingSoonBadge": "Yakında",
    "escToClose": "kapatmak için",
    "resultSingular": "{{count}} sonuç",
    "resultPlural": "{{count}} sonuç",
    "searchAcrossApp": "Tüm uygulama içinde ara"
  },
  "familyMember": {
    "confirmRemove": "{{name}} isimli kişiyi aile sağlık takibinden çıkarmak istiyor musunuz?",
    "removed": "{{name}} aileden çıkarıldı",
    "removeFailed": "Üye çıkarılamadı",
    "viewDetails": "Detayları Görüntüle",
    "edit": "Düzenle",
    "remove": "Kaldır",
    "yearsSuffix": "yaş",
    "healthGoalsLabel": "Sağlık Hedefleri:",
    "moreSuffix": "daha fazla",
    "activeInsights": "Aktif Bilgiler",
    "viewAllInsights": "Tüm {{count}} bilgiyi görüntüle →",
    "viewFullProfile": "Tam Sağlık Profilini Gör",
    "lifeStage": {
      "infant": "Bebek (0-2)",
      "toddler": "Oyun Çocuğu (2-5)",
      "child": "Çocuk (6-12)",
      "adolescent": "Genç (13-17)",
      "adult": "Yetişkin (18-59)",
      "senior": "Yaşlı (60+)",
      "unknown": "Bilinmiyor"
    }
  },
  "profileDeep": {
    "backToDashboard": "Panele geri dön",
    "profileCompletion": "Profil Tamamlama",
    "healthSummary": "Sağlık özeti",
    "sectionA": "Bölüm A",
    "sectionB": "Bölüm B",
    "sectionC": "Bölüm C",
    "sectionD": "Bölüm D",
    "personalDetails": "Kişisel bilgiler",
    "healthInformation": "Sağlık bilgileri",
    "accountSettings": "Hesap ayarları",
    "fullName": "Ad Soyad",
    "email": "E-posta",
    "dob": "Doğum tarihi",
    "gender": "Cinsiyet",
    "genderPlaceholder": "Örn: Kadın, Erkek, Belirtmek istemiyorum",
    "height": "Boy (cm)",
    "heightPlaceholder": "Örn: 170",
    "weight": "Kilo (kg)",
    "weightPlaceholder": "Örn: 70",
    "allergies": "Alerjiler",
    "allergiesPlaceholder": "Örn: Yer fıstığı",
    "medicalConditions": "Sağlık durumları",
    "conditionsPlaceholder": "Örn: Hipertansiyon",
    "medications": "İlaçlar",
    "medicationsPlaceholder": "Örn: Lisinopril 10mg, günde bir",
    "emergencyContact": "Acil durum kişisi",
    "emergencyOptional": "(isteğe bağlı)",
    "emergencyPlaceholder": "Örn: Annem +90-555-0100",
    "emergencyNote": "Sadece siz onay verdiğinizde uzman paylaşımına dahil edilir.",
    "saveChanges": "Değişiklikleri kaydet",
    "saving": "Kaydediliyor…",
    "editProfile": "Profili düzenle",
    "cancelEditing": "Düzenlemeyi iptal et",
    "healthScore": "Sağlık puanı",
    "streak": "Seri",
    "streakDays": "{{n}} gün",
    "memberSince": "Üyelik başlangıcı",
    "remindersActive": "Hatırlatıcılar aktif",
    "conditionsTracked": "Takip edilen durumlar",
    "nextAgenda": "Sıradaki adımınız",
    "notificationsReminders": "Bildirimler ve hatırlatıcılar",
    "notificationsRemindersDesc": "Sağlık hatırlatıcı zamanlarını ve kanallarını yönetin",
    "emailNudges": "E-posta dürtmeleri",
    "emailNudgesDesc": "Nazik hatırlatıcılar ve haftalık özetler",
    "on": "Açık",
    "paused": "Duraklatıldı",
    "privacySecurity": "Gizlilik ve güvenlik",
    "privacySecurityDesc": "Hesabınızı güvende tutmak için şifrenizi güncelleyin",
    "preferencesTitle": "Tercihler",
    "preferencesDesc": "Dil, bölge ve kişiselleştirme",
    "supportHelp": "Destek ve yardım",
    "supportHelpDesc": "Yanıtlar alın ve bizimle iletişime geçin",
    "giveFeedback": "Geri bildirim ver",
    "giveFeedbackDesc": "Neleri geliştirebileceğimizi bize söyleyin",
    "reportProblem": "Sorun bildir",
    "reportProblemDesc": "Hata mı buldunuz? Bize bildirin",
    "adminInsights": "Yönetici analizleri",
    "adminInsightsDesc": "Etkileşim analitiği",
    "adminBadge": "Yönetici",
    "shareWithClinician": "Bir uzmanla paylaş",
    "shareWithClinicianDesc": "Sadece okunabilir özet · otomatik olarak süresi dolar · her an geri çekilebilir",
    "share": "Paylaş",
    "profileMayBeOutOfDate": "Profil bilgileriniz güncel olmayabilir",
    "profileMayBeOutOfDateDesc": "Daha keskin analizler için esenlik verilerinizi doğru tutun; kilo veya ilaçlardaki küçük değişiklikler bile size özel yönlendirmelerimizi iyileştirir.",
    "updateNow": "Şimdi güncelle",
    "profileUpdateError": "Tercihiniz güncellenemedi. Lütfen tekrar deneyin.",
    "healthLoopUser": "HealthLoop kullanıcısı",
    "updatedLabel": "Güncellendi",
    "noEntries": "Henüz giriş yapılmadı.",
    "completionComplete": "Profiliniz tamamlandı. Size en iyi esenlik rehberliğini sunabiliriz. 💚",
    "completionAlmostThere": "Az kaldı. Birkaç detay daha ekleyerek daha keskin analizlere ulaşın.",
    "completionInProgress": "Daha iyi esenlik analizleri için profilinizi tamamlayın.",
    "justNow": "az önce",
    "minAgo": "{{n}} dk önce",
    "minsAgo": "{{n}} dk önce",
    "hourAgo": "{{n}} saat önce",
    "hoursAgo": "{{n}} saat önce",
    "dayAgo": "{{n}} gün önce",
    "daysAgo": "{{n}} gün önce",
    "checkinDueToday": "Bugünkü kontrol zamanı geldi",
    "checkinDueTonight": "Bu akşamki kontrol zamanı geldi"
  },
  "supportDeep": {
    "backToSettings": "Ayarlara geri dön",
    "quickNavAria": "Destek bölümleri",
    "searchPlaceholder": "Yardım arayın…",
    "searchAria": "Sıkça sorulan sorularda ara",
    "resultsCount": "{{n}} sonuç",
    "resultsCountPlural": "{{n}} sonuç",
    "questionsCount": "{{n}} soru",
    "liveChatTitle": "Canlı Sohbet",
    "liveChatDesc": "Bizimle gerçek zamanlı konuşun · Pzt–Cum 09:00–18:00",
    "startChat": "Sohbeti Başlat",
    "liveChatSoonToast": "Canlı sohbet yakında hizmete girecek. O zamana kadar e-posta yoluyla bize ulaşabilirsiniz.",
    "emailUsTitle": "Bize E-posta Gönderin",
    "emailUsDesc": "24–48 saat içinde yanıt verilir",
    "copy": "Kopyala",
    "emailCopied": "E-posta panoya kopyalandı.",
    "contactFormTitle": "İletişim Formu",
    "contactFormDesc": "Bize mesaj gönderin, e-posta ile yanıtlayalım.",
    "yourNameLabel": "Adınız *",
    "namePlaceholder": "Ayşe Yılmaz",
    "yourEmailLabel": "E-postanız *",
    "emailPlaceholder": "ayse@ornek.com",
    "subjectOptional": "Konu (isteğe bağlı)",
    "subjectPlaceholder": "Size nasıl yardımcı olabiliriz?",
    "messageLabel": "Mesajınız *",
    "messagePlaceholder": "İhtiyacınız olan konu hakkında kısa bir bilgi verin.",
    "sending": "Gönderiliyor…",
    "sendMessage": "Mesaj Gönder",
    "messageSent": "Mesaj gönderildi",
    "messageSentDesc": "24–48 saat içinde yanıt vereceğiz.",
    "callbackTitle": "Geri Arama Talep Et",
    "callbackDesc": "Size uygun olan bir zamanda sizi geri arayalım.",
    "phoneLabel": "Telefon numarası *",
    "phonePlaceholder": "+90 (555) 123-4567",
    "preferredTimeLabel": "Tercih edilen zaman (isteğe bağlı)",
    "preferredTimePlaceholder": "Örn: yarın öğleden sonra",
    "reasonLabel": "Sebep (isteğe bağlı)",
    "reasonPlaceholder": "Kısaca ne hakkında görüşmek istersiniz?",
    "submitting": "Gönderiliyor…",
    "requestCallback": "Geri Arama İste",
    "callbackRequested": "Geri arama talep edildi",
    "callbackRequestedDesc": "24 saat içinde sizinle iletişime geçeceğiz.",
    "medicationSupport": "İlaç Desteği",
    "medicationSupportDesc": "Reçeteleri, yenilemeleri ve hatırlatıcıları takip edin.",
    "goToMedications": "İlaçlara git →",
    "specialistConsultation": "Uzman Danışmanlığı",
    "specialistConsultationDesc": "Kişiselleştirilmiş esenlik rehberliği için bir uzmanla iletişime geçin.",
    "connectExpert": "Uzmana bağlan →",
    "videoConsult": "Görüntülü Görüşme",
    "videoConsultDesc": "Bir uzmanla yüz yüze görüntülü görüşme randevusu alın.",
    "bookConsultation": "Randevu al →",
    "premium": "Premium",
    "healthDisclaimer": "HealthLoop günlük esenliğinizi destekler; acil tıbbi müdahalenin yerini tutmaz. Acil bir durum hissederseniz lütfen yerel acil servislerle iletişime geçin.",
    "categoryLabel": "Kategori",
    "catBug": "Hata / Arıza",
    "catPerformance": "Yavaş Performans",
    "catFeature": "Özellik Çalışmıyor",
    "catUi": "Görüntüleme Sorunu",
    "catOther": "Diğer",
    "issueTitle": "Sorun başlığı *",
    "issueTitlePlaceholder": "Kısa özet",
    "detailedDescription": "Detaylı açıklama *",
    "detailedDescriptionPlaceholder": "Ne oldu? Sorun oluştuğunda ne yapıyordunuz? Adımları belirtmeniz bize çok yardımcı olur.",
    "autoAttachNote": "Cihaz, tarayıcı ve ekran bilgileri otomatik olarak eklenir.",
    "submitReport": "Raporu Gönder",
    "reportSubmitted": "Rapor gönderildi",
    "reportSubmittedDesc": "Ekibimiz konuyla ilgileniyor.",
    "fillAllFields": "Lütfen gerekli tüm alanları doldurun",
    "problemReportSubmittedToast": "Sorun raporu gönderildi. İnceleyip en kısa sürede size döneceğiz.",
    "messageSentToast": "Mesaj gönderildi. 24–48 saat içinde yanıt vereceğiz.",
    "callRequestedToast": "Arama talebi alındı. 24 saat içinde sizinle iletişime geçeceğiz.",
    "submitFailGeneric": "Gönderilemedi. Lütfen tekrar deneyin veya {{email}} adresine yazın.",
    "submitFailContact": "Gönderilemedi. Lütfen doğrudan {{email}} adresine e-posta gönderin.",
    "comingSoon": "Yakında",
    "specialistRoadmapTitle": "Bir Uzmanla Konuşun",
    "specialistRoadmapSubtitle": "İnsan desteği çok yakında. Yardım her zaman bir tık uzağınızda olacak.",
    "talkToSpecialistTitle": "Bir Uzmanla Konuşun",
    "talkToSpecialistDesc": "Günlük sağlık sorularınız için lisanslı uzmanlarla gerçek zamanlı sohbet edin.",
    "bookSpecialistTitle": "Uzman Randevusu Al",
    "bookSpecialistDesc": "Hedeflerinize uygun uzmanla bire bir görüşme planlayın.",
    "liveHealthGuidanceTitle": "Canlı Esenlik Rehberliği",
    "liveHealthGuidanceDesc": "Belirtiler, tahlil sonuçları veya planlar için anında görüntülü rehberlik.",
    "mentalWellnessTitle": "Zihinsel Esenlik Desteği",
    "mentalWellnessDesc": "Hayat zorlaştığında zihinsel sağlık profesyonellerinden gizli destek.",
    "wellnessNavigationTitle": "Esenlik Navigasyonu",
    "wellnessNavigationDesc": "Bir sonraki doğru adımı seçmenize yardımcı olan rehberli tur.",
    "pharmacyRoadmapTitle": "İlaç ve Eczane Desteği",
    "pharmacyRoadmapSubtitle": "Eczane ile ilgili yardımlar Destek bölümünde; öğrenilecek ekstra bir sekme yok.",
    "medicationGuidanceTitle": "İlaç Rehberliği",
    "medicationGuidanceDesc": "Dozaj, zamanlama ve yaygın etkileşimler hakkında sade dilde rehberlik.",
    "findNearbyPharmacyTitle": "Yakın Eczane Bul",
    "findNearbyPharmacyDesc": "İlaca ihtiyacınız olduğunda çevrenizdeki güvenilir eczaneleri hızla bulun.",
    "refillReminderTitle": "İlaç Yenileme Desteği",
    "refillReminderDesc": "Önemli ilaçlarınızın bitmemesi için nazik hatırlatıcılar.",
    "otcWellnessTitle": "Reçetesiz Ürün Danışmanlığı",
    "otcWellnessDesc": "Güvenli ve kanıta dayalı reçetesiz seçenekler hakkında küratörlü rehberlik."
  },
  "careServices": {
    "pageTitle": "Bakım Hizmetleri",
    "pageSubtitle": "Günlük sağlık yolculuğunuz için tasarlanmış uzman ve esenlik desteği.",
    "specialistCareTitle": "Uzman Bakımı",
    "specialistCareSubtitle": "Uzmanlarla konuşun ve ihtiyacınız olduğunda doğru kişiden randevu alın.",
    "medicationPharmacyTitle": "İlaç ve Eczane",
    "medicationPharmacySubtitle": "Sade dilde ilaç rehberliği ve eczane yardımı.",
    "wellnessSupportTitle": "Esenlik Desteği",
    "wellnessSupportSubtitle": "Zihinsel esenlik, reçetesiz ürün rehberliği ve net bir sonraki adım yolu.",
    "futureWellnessTitle": "Gelecek Esenlik Özellikleri",
    "futureWellnessSubtitle": "HealthLoop'un koruyucu esenlik yol haritasına bir ön bakış.",
    "futureFeatureBadge": "Gelecek Özellik",
    "futurePersonalizedMealsTitle": "Kişiselleştirilmiş Öğün Planları",
    "futurePersonalizedMealsDesc": "Hedeflerinize, alerjilerinize ve kültürünüze uygun esenlik odaklı yemek planları.",
    "futureHealthyDeliveryTitle": "Sağlıklı Yemek Teslimatı",
    "futureHealthyDeliveryDesc": "Sağlık bilincine sahip mutfaklardan ve ortaklardan seçkin teslimatlar.",
    "futureFarmFreshTitle": "Çiftlikten Taze Esenlik Gıdaları",
    "futureFarmFreshDesc": "Yerel çiftliklere ve mevsimlik taze ürün ortaklarına doğrudan erişim.",
    "futureFoodPartnershipsTitle": "Esenlik Gıdası Ortaklıkları",
    "futureFoodPartnershipsDesc": "Sağlıklı mutfaklar, marketler ve esenlik markalarıyla küratörlü ilişkiler.",
    "futureNutritionCoachingTitle": "Beslenme Koçluğu",
    "futureNutritionCoachingDesc": "Sertifikalı beslenme koçlarından bire bir rehberlik.",
    "futureFamilyWellnessTitle": "Aile Esenlik Planları",
    "futureFamilyWellnessDesc": "Tüm haneyi sağlıklı tutan ortak planlar.",
    "futureWellnessPlusTitle": "Wellness+ Üyeliği",
    "futureWellnessPlusDesc": "Kişiselleştirilmiş rehberlik, öncelikli destek ve daha derin analizler için premium katman.",
    "futurePharmacyPartnersTitle": "Eczane Ortaklıkları",
    "futurePharmacyPartnersDesc": "İlaç rehberliği ve yenilemeler için güvenilir eczane bağlantıları.",
    "futureAdvancedSpecialistTitle": "Gelişmiş Uzman Bakımı",
    "futureAdvancedSpecialistDesc": "Uzmanlara koordineli erişim, ikinci görüşler ve bakım navigasyonu.",
    "futureWellnessMarketplaceTitle": "Esenlik Pazaryeri",
    "futureWellnessMarketplaceDesc": "Denetlenmiş esenlik ürünleri ve hizmetlerinden oluşan seçkin bir pazar.",
    "futureVendorCollabTitle": "İş Ortağı İş Birliği Sistemleri",
    "futureVendorCollabDesc": "Sağlıklı gıda ve esenlik ortakları için katılım ve kalite sistemleri."
  },
  "dashboardDeep": {
    "healthProfile": "Sağlık Profili",
    "notifications": "Bildirimler",
    "familyAccounts": "Aile Hesapları",
    "settings": "Ayarlar",
    "logout": "Çıkış Yap",
    "allCaughtUp": "Her şey güncel.",
    "weekInReview": "Haftalık özetiniz",
    "dismissNotification": "Bildirimi kapat",
    "dismissWeeklyDigest": "Haftalık özeti kapat",
    "notificationsAria": "Bildirimler",
    "profileMenuAria": "Profil menüsünü aç",
    "loadingWellness": "Esenlik özetiniz yükleniyor",
    "nextTip": "Sıradaki ipucu",
    "todayAtGlance": "Bugüne bakış",
    "healthScoreLabel": "Sağlık Puanı",
    "currentStreakLabel": "Güncel Seri",
    "todaysProgress": "Bugünkü İlerleme",
    "insightForYou": "Size özel analiz",
    "checkMyHealthRisk": "Sağlık Riskimi Kontrol Et",
    "quickAccess": "Hızlı Erişim",
    "exploreCareServicesTitle": "Bakım Hizmetlerini Keşfedin",
    "exploreCareServicesSubtitle": "Uzman bakımı · eczane · esenlik — hepsi tek bir yerde.",
    "familyCare": "Aile Bakımı",
    "healthLibrary": "Sağlık Kütüphanesi",
    "myHealthData": "Sağlık Verilerim",
    "askQuestion": "Soru Sor",
    "dashLoadError": "Panel yüklenemedi. Lütfen tekrar deneyin.",
    "taskUpdateError": "Görev güncellenemedi. Lütfen tekrar deneyin.",
    "perfectDay": "Harika bir gün! 🎉 Seri uzatıldı.",
    "letsStart": "Hadi başlayalım",
    "yourNextStepToday": "Bugünkü sıradaki adımınız",
    "completeDailyCheck": "Günlük sağlık kontrolünüzü tamamlayın",
    "startDailyCheck": "Günlük Kontrolü Başlat",
    "viewAll": "Hepsini gör",
    "graceProtected": "Hak korundu",
    "todaysHealthRecommendations": "Bugünün Sağlık Önerileri",
    "updateViaCheck": "Günlük kontrol ile güncelle",
    "healthInsight": "Sağlık Analizi",
    "riskCheckSubtext": "Saniyeler içinde kişiselleştirilmiş analizler alın",
    "foodDiet": "Gıda ve Diyet",
    "healthScoreNew": "Sağlık Puanı · Yeni",
    "letsBuildScore": "Sağlık puanınızı birlikte oluşturalım",
    "oneHealthyHabitAtATime": "Her seferinde bir sağlıklı alışkanlık.",
    "nextCheck": "Sıradaki kontrol:",
    "todayAt8pm": "bugün 20:00'de",
    "wellnessTipForYou": "Günün Esenlik İpucu · Sizin için",
    "wellnessTipForFactor": "Günün Esenlik İpucu · {{factor}} için",
    "logged": "Kaydedildi",
    "gotIt": "Anladım 👍",
    "gladToSeeYou": "Sizi bugün burada görmek güzel 💚",
    "takesLessThan60Sec": "60 saniyeden az sürer",
    "scoreReadyWhenYou": "Siz hazır olduğunuzda hazır",
    "scoreCompleteFirstCheck": "Kişiselleştirilmiş analizlerin kilidini açmak için ilk esenlik kontrolünüzü tamamlayın.",
    "scoreExcellent": "Mükemmel",
    "scoreSupportExcellent": "Bugün harika bir durumdasınız. Böyle devam edin.",
    "scoreGood": "İyi",
    "scoreSupportGood": "İyi gidiyorsunuz. Sağlıklı alışkanlıklarınızı koruyun.",
    "scoreModerate": "Orta",
    "scoreSupportModerate": "İyi durumdasınız ancak birkaç alan dikkat gerektiriyor.",
    "scoreNeedsAttention": "İlgi Gerektiriyor",
    "scoreSupportNeedsAttention": "Sağlığınız bugün dikkat gerektiriyor. Küçük değişiklikler iyileşmeye yardımcı olabilir."
  },
  "emailVerify": {
    "bannerWithEmail": "Hesabınızı güvende tutmamız ve günlük bildirimlerinizi iletebilmemiz için lütfen e-postanızı ({{email}}) doğrulayın.",
    "bannerNoEmail": "Hesabınızı güvende tutmamız ve günlük bildirimlerinizi iletebilmemiz için lütfen e-postanızı doğrulayın.",
    "sending": "Gönderiliyor…",
    "resend": "E-postayı tekrar gönder",
    "sentToast": "Doğrulama e-postası gönderildi. Lütfen gelen kutunuzu kontrol edin.",
    "sendFailToast": "Doğrulama e-postası gönderilemedi. Daha sonra tekrar deneyin."
  },
  "forgotPassword": {
    "title": "Şifrenizi mi Unuttunuz?",
    "subtitle": "Sorun değil! E-postanızı girin, size sıfırlama talimatlarını gönderelim.",
    "emailLabel": "E-posta Adresi",
    "emailPlaceholder": "e-posta@ornek.com",
    "sendResetLink": "Sıfırlama Bağlantısı Gönder",
    "sending": "Gönderiliyor…",
    "backToLogin": "Giriş Sayfasına Dön",
    "resendLink": "E-postayı tekrar gönder",
    "successTitle": "E-postanızı Kontrol Edin",
    "successBody": "Eğer {{email}} adresiyle kayıtlı bir hesap varsa, şifre sıfırlama bağlantısını gönderdik.",
    "linkExpires": "Bağlantının süresi 30 dakika içinde dolacaktır.",
    "successToast": "Sıfırlama talimatları için e-postanızı kontrol edin",
    "errEmptyEmail": "Lütfen e-posta adresinizi girin",
    "errInvalidEmail": "Lütfen geçerli bir e-posta adresi girin",
    "errNetwork": "Sunucuya ulaşılamadı. Bağlantınızı kontrol edip tekrar deneyin.",
    "errGeneric": "Sıfırlama e-postası gönderilemedi. Lütfen tekrar deneyin veya destekle iletişime geçin."
  },
  "resetPassword": {
    "title": "Yeni Şifre Belirle",
    "subtitle": "Hesabınız için güçlü bir şifre oluşturun",
    "newPasswordLabel": "Yeni Şifre",
    "newPasswordPlaceholder": "Yeni şifre girin",
    "confirmPasswordLabel": "Şifreyi Onayla",
    "confirmPasswordPlaceholder": "Yeni şifreyi onaylayın",
    "requirementsHint": "En az 8 karakterden oluşmalı; büyük harf, küçük harf ve rakam içermelidir",
    "resetPassword": "Şifreyi Sıfırla",
    "resetting": "Sıfırlanıyor…",
    "successTitle": "Şifre Başarıyla Sıfırlandı!",
    "successBody": "Artık yeni şifrenizle giriş yapabilirsiniz.",
    "successToast": "Şifre başarıyla sıfırlandı!",
    "goToLogin": "Giriş Sayfasına Git",
    "invalidLinkTitle": "Geçersiz Sıfırlama Bağlantısı",
    "invalidLinkBody": "Bu şifre sıfırlama bağlantısı geçersiz veya süresi dolmuş.",
    "requestNewLink": "Yeni Bağlantı İste",
    "showPassword": "Şifreyi göster",
    "hidePassword": "Şifreyi gizle",
    "errInvalidLink": "Geçersiz sıfırlama bağlantısı",
    "errMismatch": "Şifreler eşleşmiyor",
    "errTooShort": "Şifre en az 8 karakter olmalıdır",
    "errExpiredToken": "Bu sıfırlama bağlantısının süresi dolmuş veya geçersiz. Lütfen yeni bir tane isteyin.",
    "errNetwork": "Sunucuya ulaşılamadı. Bağlantınızı kontrol edip tekrar deneyin.",
    "errGeneric": "Şifre sıfırlanamadı. Lütfen tekrar deneyin."
  },
  "tips": {
    "water1": "Uyandıktan sonraki 30 dakika içinde su içmek, sıvı dengesini ve enerji seviyelerini iyileştirebilir.",
    "water2": "Her öğünden önce bir bardak su içmek, susuzluğun önüne geçmenin nazik bir yoludur.",
    "water3": "Suyunuza bir dilim limon veya birkaç nane yaprağı eklemek, su içmeyi bir keyfe dönüştürebilir.",
    "meals1": "Günde bir porsiyon fazla sebze eklemek, bağırsak ve kalp sağlığını destekler.",
    "meals2": "Kahvaltıda bir avuç kuruyemiş veya tohum tüketmek, sabah boyunca enerjinizi dengeler.",
    "meals3": "Bütün meyve, meyve suyundan daha iyidir; lifler kan şekerinizin daha dengeli kalmasını sağlar.",
    "steps1": "Öğünlerden sonra yapılan 10 dakikalık bir yürüyüş, vücudunuzun şekerleri daha rahat işlemesine yardımcı olur.",
    "steps2": "5 dakikalık bir sabah esnemesi, gerginliği azaltabilir ve gününüze sakin bir başlangıç yapmanızı sağlar.",
    "steps3": "Günde bir kez bile merdiven kullanmak, haftalar içinde kalp gücünüzü sessizce artırır.",
    "sleep1": "Uykudan bir saat önce ışıkları kısmak, vücudunuzun derin uykuya hazırlanmasına yardımcı olur.",
    "sleep2": "Hafta sonları bile tutarlı bir uyanma saati belirlemek, daha dengeli bir uyku döngüsü sağlar.",
    "sleep3": "Sabahları 10 dakika güneş ışığı almak, uyku ritminizi doğal olarak düzenlemeye yardımcı olur.",
    "general1": "İki dakikalık yavaş nefes egzersizi stresi azaltabilir ve odaklanmanızı güçlendirebilir.",
    "general2": "Bugün bir şükran anını fark edin; küçük zihinsel kazanımlar zamanla büyür.",
    "general3": "Bugün buradasınız. Bu, diğer tüm alışkanlıkları kolaylaştıran temel alışkanlıktır."
  },
  "factors": {
    "hydration": "sıvı alımı",
    "nutrition": "beslenme",
    "movement": "hareket",
    "sleep": "uyku"
  },
  "nutritionDeep": {
    "mealOptionsLoadFail": "Öğün seçenekleri yüklenemedi",
    "prefsSaved": "Beslenme tercihleri kaydedildi! Öğünler güncelleniyor...",
    "prefsSaveFail": "Tercihler kaydedilemedi",
    "newOptionsFail": "Yeni seçenekler yüklenemedi",
    "invalidZip": "Lütfen geçerli bir posta kodu girin",
    "noVendorsArea": "Bu bölgede henüz bir satıcı bulunmuyor. Kapsama alanımızı genişletiyoruz!",
    "vendorsFetchFail": "Satıcılar getirilemedi",
    "selectVendorFirst": "Lütfen önce bir teslimat satıcısı seçin",
    "removedFromCart": "Sepetten çıkarıldı",
    "orderPlaced": "Sipariş başarıyla oluşturuldu! 🎉",
    "enterZipFirst": "Lütfen önce teslimat bölümüne posta kodunuzu girin",
    "mealNotAvailable": "Bu öğün henüz bölgenizde teslimata uygun değil",
    "mealUnavailable": "Bu öğün şu anda yakındaki satıcılarda bulunmuyor",
    "vendorOptionsFail": "Satıcı seçenekleri yüklenemedi",
    "favoriteSaveFail": "Favorilere kaydedilemedi",
    "removedFromFavorites": "Favorilerden çıkarıldı",
    "favoriteRemoveFail": "Favorilerden çıkarılamadı",
    "cartEmpty": "Sepetiniz boş",
    "noMealOptions": "Öğün seçeneği bulunmuyor",
    "loadingOptions": "Öğün seçenekleri yükleniyor...",
    "selectPreferences": "Beslenme Tercihlerinizi Seçin",
    "mealBuilder": "Öğün Oluşturucu",
    "myFavorites": "Favorilerim",
    "myFavoriteMeals": "Favori Öğünlerim",
    "noFavoritesYet": "Henüz favori öğününüz yok!",
    "price": "Fiyat",
    "delivery": "Teslimat",
    "deliveryFee": "Teslimat Ücreti",
    "distance": "Mesafe",
    "subtotal": "Ara Toplam",
    "total": "Toplam",
    "orderNumber": "Sipariş Numarası",
    "vendor": "Satıcı",
    "totalAmount": "Toplam Tutar",
    "estimatedDelivery": "Tahmini Teslimat",
    "whyThisMeal": "Neden bu öğün?",
    "selectThisMeal": "Bu Öğünü Seç",
    "swapMeal": "Öğünü Değiştir",
    "orderThisMeal": "Bu Öğünü Sipariş Et",
    "notAvailableNearYou": "Yakınınızda bulunmuyor",
    "tryAdjustingPrefs": "Öğün önerilerini görmek için beslenme tercihlerinizi ayarlamayı deneyin",
    "myMealPlanSummary": "Beslenme Planı Özetim",
    "saveCompletePlan": "Tam Planı Kaydet",
    "yourFoodPreferences": "Beslenme Tercihleriniz",
    "editPreferences": "Tercihleri Düzenle",
    "healthyMealDelivery": "Sağlıklı Öğün Teslimatı",
    "enableDelivery": "Teslimatı Etkinleştir",
    "enterZipCode": "Mevcut Öğünleri Görmek İçin Posta Kodunuzu Girin",
    "enterPostcode": "Posta Kodunuzu Girin",
    "postcodePlaceholder": "Örn: 34000 veya 10001",
    "postcodePartialHint": "Daha doğru yerel sonuçlar için lütfen posta kodunuzun tamamını girin.",
    "noLocalPartnersFallback": "Henüz yerel ortak bulunamadı. Bunun yerine kültürel olarak uygun malzeme önerileri gösteriliyor.",
    "noLivePartnersFallback": "Bölgenizde henüz aktif HealthLoop gıda ortağı bulunmamaktadır.",
    "culturalNutritionTitle": "Yerel Sağlıklı Keşifler",
    "culturalNutritionSubtitle": "Kişiselleştirilmiş sağlıklı yaşam rehberliği — kültürel olarak uygun, bilgilendirici ve bölgenize özel.",
    "viewIngredientGuidance": "Rehberi Görüntüle",
    "popularWellnessTitle": "Yakınınızdaki Popüler Sağlıklı Gıdalar",
    "popularWellnessIntro": "Bölgenizde yaygın olan kültürel malzemeler ve insanların genellikle tercih ettiği sağlıklı gıda ortamları.",
    "subsectionPopularFoodsTitle": "Günlük Sağlıklı Gıdalar",
    "subsectionCulturalIngredientsTitle": "Kültürel Malzeme Önerileri",
    "subsectionHealthySwapsTitle": "Sağlıklı Değişim Fikirleri",
    "subsectionLocalEnvironmentTitle": "Yerel Sağlıklı Yaşam Ortamı",
    "subsectionLocalEnvironmentIntro": "Bölgenizdeki insanların kültürel açıdan uygun ve sağlıklı seçenekler bulduğu yerler.",
    "findLocalTitle": "Yerel Sağlıklı Seçenekler",
    "findLocalSubtitle": "Bölgenizdeki sağlıklı satıcıları, mağazaları ve kültürel malzemeleri keşfedin.",
    "findOptions": "Seçenekleri Bul",
    "searching": "Aranıyor…",
    "nearbyVendorsFound": "{{count}} adet yakın sağlıklı seçenek bulundu",
    "orderHintEnabled": "Satıcı fiyatlarını görmek için aşağıdaki öğün kartlarından \"Bu Öğünü Sipariş Et\"e dokunun.",
    "orderHintDisabled": "Doğrudan sipariş vermek için yukarıdaki \"Teslimatı Etkinleştir\" seçeneğini açın.",
    "localIngredientTitle": "Yerel Malzeme Bulunabilirliği",
    "localIngredientIntro": "Kültürel temel gıdalar ve bunları yerel olarak nereden temin edebileceğiniz.",
    "lookFor": "Şunlara bakın:",
    "noVendorsFallback": "Henüz onaylı bir teslimat satıcısı yok; ancak yukarıdaki malzeme rehberi yerel marketlerde veya pazarlarda size yardımcı olacaktır.",
    "showingMealsFrom": "Şu kaynaktan öğünler gösteriliyor:",
    "sectionSnapshot": "Günlük Beslenme Özeti",
    "sectionSnapshotSubtitle": "Bugünkü su tüketimi, kalori ve öğün dengesine hızlı bir bakış.",
    "snapshotHydration": "Su Tüketimi",
    "snapshotHydrationHint": "Bugün 6–8 bardak hedefleyin.",
    "snapshotCalories": "Kalori",
    "snapshotCaloriesHint": "Takip özelliği yakında gelecek.",
    "snapshotBalance": "Öğün Dengesi",
    "mealsLogged": "öğün seçildi",
    "snapshotTip": "Sağlıklı Yaşam İpucu",
    "snapshotTipHint": "Bir sonraki öğününüze ekstra bir sebze ekleyin.",
    "sectionRecommendations": "Akıllı Öneriler",
    "sectionRecommendationsSubtitle": "Kültürel olarak uygun malzeme rehberliği ve sağlıklı değişim fikirleri.",
    "sectionGoals": "Beslenme Hedefleri",
    "sectionGoalsSubtitle": "Sizin için önemli olan sonuçları takip edin.",
    "goalWeight": "Kilo Kontrolü",
    "goalWeightDesc": "Sürdürülebilir kilo hedefi için ayarlanan öğünler.",
    "goalEnergy": "Enerji Desteği",
    "goalEnergyDesc": "Uzun ve verimli günler için dengeli enerji kaynağı.",
    "goalImmunity": "Bağışıklık Desteği",
    "goalImmunityDesc": "Zinde kalmak için antioksidan bakımından zengin seçenekler.",
    "goalFamily": "Aile Beslenmesi",
    "goalFamilyDesc": "Çocuk dostu ve anne beslenmesine uygun seçenekler dahil.",
    "sectionGuidance": "Öğün Rehberi",
    "sectionGuidanceSubtitle": "Serbestçe değiştirebileceğiniz kahvaltı, öğle yemeği, akşam yemeği ve atıştırmalık fikirleri.",
    "futureNutritionTitle": "Gelecek Beslenme Desteği",
    "futureNutritionBody": "Kişiselleştirilmiş sağlıklı beslenme, sağlıklı öğün ortaklıkları ve aile odaklı gıda desteği gelecek güncellemelerle HealthLoop'a eklenecektir.",
    "comingSoon": "Yakında",
    "coverageLocalStores": "Yerel sağlıklı mağazalar",
    "coverageLocalFarms": "Yerel çiftlikler",
    "coverageCertifiedVendors": "Onaylı satıcılar",
    "coverageFreshProduce": "Taze ürünler",
    "medWellnessFutureTitle": "İlaç ve Sağlıklı Yaşam Desteği",
    "medWellnessFutureDesc": "Beslenme planınızı ilaç kullanımına duyarlı rehberlikle eşleştirir. Bu özellik Destek ve Yardım bölümünde yer alacaktır.",
    "pharmacyAssistFutureTitle": "Eczane Yardımı",
    "pharmacyAssistFutureDesc": "Öğünlerinizin hemen yanında yakındaki eczaneleri bulun ve hatırlatıcılar kurun. Bu özellik Destek ve Yardım bölümünde yer alacaktır.",
    "savePreferences": "Tercihleri Kaydet",
    "quickAccessSavedMeals": "Kaydedilen öğünlerinize hızlı erişim",
    "saveMealsFromBuilder": "Öğün Oluşturucu sekmesinden öğünleri kaydedin",
    "chooseVendor": "Bu öğünü sipariş etmek için bir satıcı seçin",
    "yourCart": "Sepetiniz",
    "addMealsToStart": "Başlamak için aşağıdaki seçeneklerden öğün ekleyin",
    "orderPlacedDesc": "Sağlıklı öğün siparişiniz başarıyla oluşturuldu",
    "continueShopping": "Alışverişe Devam Et",
    "trackOrder": "Siparişi Takip Et",
    "healthyStoresTitle": "Yakındaki Sağlıklı Mağazalar ve Esenlik Marketleri",
    "healthyStoresIntro": "Bölgenizde arayabileceğiniz kültürel açıdan kapsayıcı mağaza türleri — teslimat için değil, fikir amaçlıdır.",
    "healthyStoresGuidanceTitle": "Sağlıklı alışveriş rehberliği",
    "healthyStoresDisclaimer": "HealthLoop yalnızca genel esenlik ve sağlıklı alışveriş ilhamı paylaşır; tıbbi veya diyet tedavisi tavsiyesi sunmaz.",
    "healthyStores": {
      "organic": {
        "type": "Organik gıda mağazaları",
        "description": "Taze, pestisitsiz ürünler ve az işlenmiş temel kiler ürünleri.",
        "tags": [
          "Doğal-gıdalar",
          "Taze sebze-meyve"
        ]
      },
      "farmers": {
        "type": "Semt pazarları",
        "description": "Doğrudan üreticiden gelen yerel yetişmiş mevsimlik meyveler, sebzeler ve geleneksel ürünler.",
        "tags": [
          "Yerel",
          "Mevsimsel"
        ]
      },
      "african": {
        "type": "Afrika taze ürün mağazaları",
        "description": "Yer elması, muz, yeşil yapraklı sebzeler, palmiye fıstığı ve Batı / Doğu Afrika temel gıdaları.",
        "tags": [
          "Kültürel",
          "Taze sebze-meyve"
        ]
      },
      "caribbean": {
        "type": "Karayip doğal gıda marketleri",
        "description": "Callaloo, manyok, acı biber, ackee, ekmek ağacı meyvesi ve ada temel gıdaları.",
        "tags": [
          "Kültürel",
          "Doğal-gıdalar"
        ]
      },
      "asian": {
        "type": "Asya sebze süpermarketleri",
        "description": "Bok choy, daikon, lotus kökü, tofu, taze otlar ve Pan-Asya temel gıdaları.",
        "tags": [
          "Kültürel",
          "Taze sebze-meyve"
        ]
      },
      "halal": {
        "type": "Helal sağlıklı gıda marketleri",
        "description": "Helal sertifikalı yağsız proteinler, taze ürünler ve geleneksel baharatlar.",
        "tags": [
          "Helal",
          "Kültürel"
        ]
      },
      "mediterranean": {
        "type": "Akdeniz doğal gıda marketleri",
        "description": "Zeytinyağı, baklagiller, taze otlar, tam tahıllar ve Akdeniz temel gıdaları.",
        "tags": [
          "Kültürel",
          "Doğal-gıdalar"
        ]
      },
      "wellness": {
        "type": "Esenlik odaklı marketler",
        "description": "Özenle seçilmiş doğal gıdalar, bitki bazlı seçenekler ve temiz içerikli kiler ürünleri.",
        "tags": [
          "Doğal-gıdalar",
          "Bitki-bazlı"
        ]
      }
    },
    "healthyShoppingTips": [
      "Önce reyonların dış çeperinden alışveriş yapın — taze sebze-meyve, yağsız proteinler ve süt alternatifleri genellikle kenarlarda bulunur.",
      "Aşırı işlenmiş ürünler yerine tam ve tek bileşenli gıdaları tercih edin.",
      "Yerel mevsim ürünlerini seçin — bunlar genellikle daha taze, daha uygun fiyatlı ve besin değeri daha yüksektir.",
      "Satıcılara ürünlerin menşei ve yetiştirme yöntemleri hakkında sorular sorun — birçoğu bunu memnuniyetle paylaşacaktır."
    ]
  },
  "messages": {
    "success": "Başarılı!",
    "error": "Hata",
    "saved": "Başarıyla kaydedildi",
    "updated": "Başarıyla güncellendi",
    "deleted": "Başarıyla silindi",
    "confirmDelete": "Bunu silmek istediğinizden emin misiniz?",
    "networkError": "Ağ hatası. Lütfen tekrar deneyin.",
    "somethingWrong": "Bir şeyler ters gitti",
    "failedToLoad": "Panel yüklenemedi",
    "offlineMode": "Çevrimdışı mod - sınırlı veri gösteriliyor",
    "locationDenied": "Konum erişimi reddedildi. Etkinleştirmek için tarayıcı ayarlarını kontrol edin.",
    "locationUnavailable": "Konum bilgisine ulaşılamıyor",
    "locationTimeout": "Konum isteği zaman aşımına uğradı. Lütfen tekrar deneyin.",
    "locationError": "Konuma erişilemiyor",
    "locationGranted": "Konum erişimi onaylandı! Yakındaki seçenekler gösteriliyor",
    "locationNotSupported": "Konum servisleri tarayıcınız tarafından desteklenmiyor",
    "requestingLocation": "Konum erişimi isteniyor..."
  },
  "trust": {
    "medicalDisclaimer": "Sorumluluk Reddi",
    "privacySecure": "Verileriniz gizli ve güvendedir",
    "dataEncrypted": "Tüm veriler şifrelenir ve gizli tutulur",
    "notMedicalAdvice": "Tıbbi tavsiye değildir",
    "consultProvider": "Daima sağlık uzmanınıza danışın",
    "evidenceBased": "Kanıta dayalı rehberlik",
    "generalEducation": "Genel sağlık eğitimi",
    "preventiveGuidance": "Önleyici rehberlik",
    "lifestyleSupport": "Farkındalık ve yaşam tarzı desteği için",
    "lastUpdated": "Son güncelleme",
    "expertReviewed": "Uzmanlarca incelendi",
    "aiGenerated": "Yapay zeka destekli analiz",
    "disclaimerShort": "HealthLoop sağlık eğitimi sunar ve profesyonel sağlık rehberliğinin yerini tutmaz.",
    "disclaimerFull": "HealthLoop önleyici zindeliği ve erken farkındalığı destekler. Sağlık eğitimi, alışkanlık takibi ve zindelik analizleri sunuyoruz. Bu hizmetler lisanslı tıbbi bakımın yerini tutmaz. Sağlıklı yaşam rehberliği, tanı veya süreçler için daima yetkili sağlık kuruluşlarına danışın.",
    "trustBanner": {
      "title": "HealthLoop sağlıklı yaşam yolculuğunuzu desteklemek için burada",
      "description": "Güvenilir kaynaklara dayalı genel sağlık eğitimi ve önleyici rehberlik sunuyoruz. Bu bilgiler profesyonel sağlık tavsiyesi yerine geçmez. Sağlık kararlarınız için daima uzman bir görüşe başvurun."
    }
  },
  "health": {
    "preventiveHealth": "Önleyici Sağlık Takibi",
    "educationHub": "Eğitim Merkezi",
    "engagementWidget": "Etkileşim Aracı",
    "wellnessCheckIn": "Günlük Durum Değerlendirmesi",
    "todaysMetrics": "Bugünkü Ölçümler",
    "bloodPressure": "Kan Basıncı",
    "heartRate": "Nabız",
    "weight": "Kilo",
    "sleep": "Uyku",
    "waterIntake": "Su Tüketimi",
    "exercise": "Egzersiz",
    "logMetric": "Veri Kaydet",
    "viewHistory": "Geçmişi Görüntüle"
  },
  "aiInsights": {
    "title": "Yapay Zeka Sağlık Analizleri",
    "comingSoon": "Analizleriniz hazırlanıyor",
    "comingSoonDesc": "Birkaç günlük durum değerlendirmesini tamamlayın, size özel nazik analizleri burada sunmaya başlayalım.",
    "learnMore": "Daha fazla bilgi al",
    "evidenceSources": {
      "WHO": "WHO (DSÖ) kılavuzlarına dayanmaktadır",
      "NHS": "NHS önerileriyle uyumludur",
      "CDC": "CDC kılavuzlarıyla desteklenmektedir",
      "RESEARCH": "Hakemli araştırmalara dayanmaktadır",
      "CLINICAL": "Klinik çalışmalarla desteklenmektedir"
    }
  },
  "dailyInsight": {
    "title": "Günlük Sağlık Analizi",
    "gettingStarted": "Başlarken",
    "focus": "Odak",
    "quickInsight": "Hızlı Bakış",
    "simpleExplanation": "Basit Açıklama",
    "realLifeImpact": "Günlük Hayata Etkisi",
    "yourActionStep": "Eylem Adımınız",
    "basedOnYour": "Şu verilerinize göre:",
    "personalizedFor": "Son sağlık verilerinize dayanarak size özel hazırlanmıştır",
    "getNewInsight": "Yeni analiz al",
    "newInsightLoaded": "Yeni analiz yüklendi! 💡",
    "failedToRefresh": "Analiz yenilenemedi",
    "priority": {
      "high": "Buna Odaklanalım",
      "medium": "Not Etmeye Değer"
    }
  },
  "preventiveAlerts": {
    "noAlertsTitle": "Şu an için sağlık uyarısı yok",
    "noAlertsDesc": "Sağlıklı alışkanlıklarınızı sürdürüyorsunuz. Böyle devam edin!",
    "whatYouCanDo": "Yapabilecekleriniz:",
    "viewMealSuggestions": "Kişiselleştirilmiş Öğün Önerilerini Gör"
  },
  "engagement": {
    "currentStreak": "Mevcut Seri",
    "bestStreak": "En İyi Seri",
    "thisWeek": "Bu Hafta",
    "exerciseDays": "Egzersiz Günleri",
    "hydrationDays": "Su Tüketimi Günleri",
    "healthMetricsLogged": "Kaydedilen Sağlık Verileri",
    "weeklyGoalsProgress": "Haftalık Hedef İlerlemesi",
    "completed": "tamamlandı",
    "days": "gün",
    "keepGoing": "Devam edin!",
    "personalRecord": "Kişisel rekor!",
    "goalMet": "Hedefe ulaşıldı!"
  },
  "reminders": {
    "title": "Sağlık Hatırlatıcıları",
    "subtitle": "Kişiselleştirilmiş sağlık bildirimleriyle yolunuzda kalın",
    "breakfast": "Kahvaltı Hatırlatıcısı",
    "lunch": "Öğle Yemeği Hatırlatıcısı",
    "dinner": "Akşam Yemeği Hatırlatıcısı",
    "water": "Su Tüketimi",
    "movement": "Hareket Molası",
    "sleep": "Uyku Hatırlatıcısı",
    "wellness": "Günlük Durum Değerlendirmesi",
    "healthLogging": "Sağlık Kaydı",
    "annualCheckup": "Yıllık Kontrol",
    "enable": "Etkinleştir",
    "disable": "Devre Dışı Bırak",
    "customize": "Saati Özelleştir",
    "stayConsistent": "Akıllı Hatırlatıcılarla İstikrar Sağlayın",
    "setupFriendly": "Sağlıklı alışkanlıklar edinmenize yardımcı olacak nazik hatırlatıcılar kurun.",
    "customizeWhen": "Her hatırlatıcıyı ne zaman ve ne sıklıkla alacağınızı özelleştirebilirsiniz.",
    "supportive": "Merak etmeyin - hatırlatıcılarımız destekleyici ve rahatsız etmeyen türdendir! 💚",
    "noPreferences": "Hatırlatıcı Tercihi Bulunamadı",
    "noPreferencesDesc": "Hatırlatıcı ayarlarınız yüklenemedi. Bu ilk ziyaretiniz olabilir veya bir yükleme sorunu yaşanmış olabilir.",
    "retryLoading": "Tekrar Dene",
    "saveSettings": "Ayarları Kaydet",
    "saving": "Kaydediliyor..."
  },
  "empty": {
    "startJourney": "Sağlıklı Yaşam Yolculuğuna Başlayın",
    "startJourneyDesc": "Sağlık yolculuğunuza bugün başlayın! Size özel analizler almak ve zindeliğinizi zaman içinde takip etmek için nasıl hissettiğinizi paylaşın.",
    "completeFirstCheckIn": "İlk Değerlendirmeyi Tamamla",
    "stayOnTrack": "Düzeninizi Koruyun",
    "stayOnTrackDesc": "Rutininize sadık kalın 💊 Nazik hatırlatıcılar ve destek almak için ilaçlarınızı ekleyin.",
    "addFirstMedication": "İlk İlacı Ekle",
    "learnMedicationSafety": "İlaç Güvenliği Hakkında Bilgi Edinin",
    "buildMealLibrary": "Öğün Kitaplığınızı Oluşturun",
    "buildMealLibraryDesc": "Henüz favori öğününüz yok. Hızlı erişim ve kolay planlama için sevdiğiniz öğünleri kaydedin.",
    "exploreMealOptions": "Öğün Seçeneklerini Keşfedin",
    "insightsAwait": "Analizleriniz Sizi Bekliyor",
    "insightsAwaitDesc": "Kişiselleştirilmiş sağlık analizlerini ve alışkanlık modellerini açmak için günlük değerlendirmeleri tamamlayın.",
    "startDailyCheckIn": "Günlük Değerlendirmeye Başla",
    "learnAboutInsights": "Analizler Hakkında Bilgi Al",
    "buildingStory": "Zindelik Hikayenizi Oluşturun",
    "buildingStoryDesc": "Henüz geçmiş veri yok. Günlük değerlendirmeleri tamamladıkça sağlık eğilimleriniz ve modelleriniz burada görünecektir.",
    "completeCheckIn": "Değerlendirmeyi Tamamla",
    "tipComplete7Days": "İpucu: Anlamlı eğilimler ve modeller görmek için 7 gün boyunca değerlendirmeleri tamamlayın.",
    "startTrackingHabits": "Sağlıklı Alışkanlıkları Takip Etmeye Başlayın",
    "startTrackingHabitsDesc": "Henüz takip edilen alışkanlık yok. Küçük günlük adımlar kalıcı sağlıklı yaşam değişimleri yaratır.",
    "trackFirstHabit": "İlk Alışkanlığı Takip Et",
    "getMoving": "Harekete Geçin",
    "getMovingDesc": "Henüz kaydedilen aktivite yok. 10 dakikalık bir hareket bile modunuzu ve enerjinizi yükseltebilir.",
    "logActivity": "Aktivite Kaydet",
    "allCaughtUp": "Her Şey Yolunda!",
    "allCaughtUpDesc": "Yeni bildiriminiz yok. Güncellemeler ve sağlıklı yaşam hatırlatıcıları için sonra tekrar kontrol edin.",
    "noResultsFound": "Sonuç Bulunamadı",
    "noResultsFoundDesc": "\"{query}\" için sonuç bulamadık. Aramanızı ayarlamayı deneyin veya diğer seçenekleri keşfedin."
  },
  "footer": {
    "tagline": "Yapay Zeka Destekli Önleyici Sağlık Rehberiniz",
    "builtWith": "Sağlık yolculuğunuz için özenle hazırlandı",
    "allRightsReserved": "Tüm hakları saklıdır.",
    "about": "Hakkımızda",
    "privacy": "Gizlilik",
    "terms": "Şartlar",
    "contact": "İletişim",
    "helpCenter": "Yardım Merkezi"
  },
  "modals": {
    "feedback": {
      "title": "Görüşlerinizi Paylaşın",
      "subtitle": "HealthLoop'u geliştirmemize yardımcı olun",
      "whatWorking": "En çok neleri beğendiniz?",
      "whatImprove": "Neleri geliştirebiliriz?",
      "placeholder": "Düşüncelerinizi paylaşın...",
      "thankYou": "Geri bildiriminiz için teşekkürler!",
      "submitted": "Görüşleriniz HealthLoop'u daha iyi hale getirmemize yardımcı oluyor."
    },
    "reportProblem": {
      "title": "Sorun Bildir",
      "subtitle": "Hataları düzeltmemize ve uygulamayı geliştirmemize yardımcı olun",
      "describe": "Sorunu açıklayın",
      "placeholder": "Ne oldu? Lütfen olabildiğince detaylı anlatın...",
      "optional": "İsteğe bağlı: Hatayı tekrarlama adımları",
      "stepsPlaceholder": "1. Şuna tıkladım...\n2. Sonra...",
      "thankYou": "Bildiriminiz için teşekkürler!",
      "submitted": "Bu konuyu hemen inceleyeceğiz."
    },
    "mealPreferences": {
      "title": "Öğünlerinizi Kişiselleştirin",
      "subtitle": "Bize yemek tercihlerinizden bahsedin",
      "cuisines": "Tercih Edilen Mutfaklar",
      "selectCuisines": "Size uygun olanları seçin",
      "dietary": "Beslenme Tercihleri",
      "selectDietary": "Beslenme ihtiyaçlarınızı seçin",
      "allergies": "Alerjiler ve Kısıtlamalar",
      "allergiesPlaceholder": "Örn: Kuruyemiş, Deniz ürünleri, Glüten",
      "save": "Tercihleri Kaydet",
      "saving": "Kaydediliyor..."
    },
    "upgrade": {
      "title": "Premium'a Geç",
      "subtitle": "Tüm özelliklerin kilidini açın",
      "features": "Premium Özellikler",
      "getStarted": "Hemen Başla",
      "learnMore": "Daha Fazla Bilgi"
    }
  },
  "login": {
    "title": "Önleyici Sağlık Zekası Platformunuz",
    "subtitle": "Sorunlar büyümeden takip edin, öğrenin ve harekete geçin. Önleme, eğitim, etkileşim ve zindelik için tasarlandı.",
    "email": "E-posta",
    "password": "Şifre",
    "signIn": "Giriş Yap",
    "signingIn": "Giriş yapılıyor...",
    "forgotPassword": "Şifremi Unuttum",
    "noAccount": "Hesabınız yok mu?",
    "createAccount": "Yeni hesap oluştur",
    "biometricLogin": "Biyometrik Giriş",
    "biometricHelper": "Parmak izi, Face ID veya Windows Hello kullanın",
    "authenticating": "Doğrulanıyor...",
    "vendorPartner": "İş ortağı mısınız?",
    "vendorLogin": "İş Ortağı Girişi",
    "emailRequired": "Lütfen önce e-posta adresinizi girin",
    "biometricSuccess": "Biyometrik giriş başarılı! 🎉",
    "noPasskeys": "Biyometrik giriş ayarlanmamış. Lütfen önce şifrenizle giriş yapın.",
    "biometricCancelled": "Biyometrik giriş iptal edildi",
    "biometricFailed": "Biyometrik giriş başarısız. Lütfen şifrenizle deneyin."
  },
  "register": {
    "title": "HealthLoop'a Katılın",
    "subtitle": "Önleyici sağlık yolculuğunuza bugün başlayın",
    "fullName": "Ad Soyad",
    "email": "E-posta",
    "password": "Şifre",
    "confirmPassword": "Şifreyi Onayla",
    "createAccount": "Hesap Oluştur",
    "haveAccount": "Zaten hesabınız var mı?",
    "signIn": "Giriş Yap",
    "creating": "Hesap oluşturuluyor...",
    "passwordTooShort": "Şifre en az 8 karakter olmalıdır",
    "setupBiometric": "Biyometrik Girişi Ayarla",
    "setupBiometricDesc": "Daha hızlı ve güvenli giriş için parmak izi, Face ID veya Windows Hello kullanın",
    "setupNow": "Biyometrik Girişi Ayarla",
    "skipForNow": "Şimdilik Atla",
    "settingUp": "Ayarlanıyor...",
    "benefit1": "Hatırlanması gereken şifre derdine son",
    "benefit2": "Biyometrik doğrulama ile ekstra güvenlik",
    "benefit3": "Tek bir dokunuş veya bakışla giriş yapın",
    "biometricPrivacy": "Biyometrik verileriniz cihazınızdan asla dışarı çıkmaz",
    "biometricSuccess": "Biyometrik giriş başarıyla ayarlandı! 🎉",
    "biometricFailed": "Biyometrik giriş ayarlanamadı. Daha sonra ayarlardan yapabilirsiniz.",
    "biometricSetupLater": "Biyometrik girişi daha sonra profil ayarlarınızdan yapabilirsiniz"
  },
  "womensHealthPage": {
    "title": "Kadın Sağlığı Takibi",
    "subtitle": "Döngünüzü, belirtilerinizi ve zindeliğinizi takip edin",
    "cycleOverview": "Döngü Özeti",
    "currentPhase": "Mevcut Evre",
    "nextPeriod": "Beklenen Sonraki Dönem",
    "logPeriod": "Dönem Kaydet",
    "logSymptoms": "Belirti Kaydet",
    "insights": "Döngü Analizleri",
    "tips": "Evreye Özel İpuçları",
    "history": "Geçmiş Kayıtlar",
    "noData": "Henüz döngü verisi yok",
    "noDataDesc": "Kişiselleştirilmiş analizler ve tahminler almak için döngünüzü takip etmeye başlayın.",
    "startTracking": "Takibe Başla"
  },
  "notifications": {
    "title": "Bildirimler",
    "markAllRead": "Tümünü Okundu İşaretle",
    "noNotifications": "Yeni bildirim yok",
    "viewAll": "Tümünü Gör"
  },
  "familyHealth": {
    "title": "Aile ve Çocuk Sağlığı",
    "subtitle": "Tüm aileniz için önleyici sağlık desteği",
    "tabImmunizations": "Aşılar",
    "tabEducation": "Eğitim",
    "tabReminders": "Hatırlatıcılar",
    "tabPlanner": "Aile Planlayıcı",
    "immunizations": {
      "title": "Aşı Farkındalığı",
      "subtitle": "Önerilen aşılar hakkında bilgi sahibi olun",
      "recommendedSchedule": "Önerilen Takvim",
      "byAge": "Yaş Grubuna Göre",
      "infants": "Bebekler (0-12 ay)",
      "toddlers": "Küçük Çocuklar (1-3 yaş)",
      "preschool": "Okul Öncesi (4-6 yaş)",
      "schoolAge": "Okul Çağı (7-12 yaş)",
      "teens": "Gençler (13-18 yaş)",
      "adults": "Yetişkinler",
      "learnMore": "Daha Fazla Bilgi",
      "consultDoctor": "Kişiye özel aşı önerileri için her zaman sağlık uzmanınıza danışın",
      "upcomingReminders": "Yaklaşan Aşı Hatırlatıcıları",
      "noReminders": "Yaklaşan aşı hatırlatıcısı yok",
      "addReminder": "Aşı Hatırlatıcısı Ekle",
      "reminderFor": "Kimin İçin",
      "dueDate": "Hatırlatma Tarihi",
      "notes": "Notlar",
      "markComplete": "Tamamlandı Olarak İşaretle"
    },
    "education": {
      "title": "Aile Sağlığı Eğitimi",
      "subtitle": "Bilimsel temelli önleyici sağlık bilgileri",
      "categories": "Kategoriler",
      "infant": "Bebek Bakımı",
      "child": "Çocuk Gelişimi",
      "nutrition": "Beslenme ve Büyüme",
      "safety": "Güvenlik ve Korunma",
      "mental": "Zihinsel Sağlık",
      "hygiene": "Hijyen ve Alışkanlıklar",
      "searchPlaceholder": "Sağlık konularında arama yapın...",
      "popularTopics": "Popüler Konular",
      "readMore": "Devamını Oku",
      "readTime": "dk okuma"
    },
    "reminders": {
      "title": "Aile Sağlığı Hatırlatıcıları",
      "subtitle": "Tüm ailenin önleyici bakımlarını takipte kalın",
      "createReminder": "Hatırlatıcı Oluştur",
      "familyMember": "Aile Üyesi",
      "reminderType": "Hatırlatıcı Türü",
      "frequency": "Sıklık",
      "activeReminders": "Aktif Hatırlatıcılar",
      "upcomingThisWeek": "Bu Haftaki Randevular",
      "noActiveReminders": "Aktif hatırlatıcı yok",
      "types": {
        "checkup": "Sağlık Kontrolü",
        "dental": "Diş Muayenesi",
        "vision": "Göz Taraması",
        "vaccine": "Aşı",
        "medication": "İlaç",
        "custom": "Özel"
      }
    },
    "planner": {
      "title": "Aile Sağlığı Planlayıcısı",
      "subtitle": "Ailenizin önleyici bakımlarını koordine edin",
      "addMember": "Aile Üyesi Ekle",
      "memberName": "Üye Adı",
      "relationship": "Yakınlık Derecesi",
      "dateOfBirth": "Doğum Tarihi",
      "viewCalendar": "Takvimi Görüntüle",
      "upcomingCare": "Yaklaşan Önleyici Bakımlar",
      "nothingScheduled": "Henüz planlanmış bir etkinlik yok",
      "scheduleCheckup": "Randevu Planla",
      "relationships": {
        "child": "Çocuk",
        "spouse": "Eş",
        "parent": "Ebeveyn",
        "sibling": "Kardeş",
        "other": "Diğer"
      }
    },
    "content": {
      "infantCare": {
        "title": "Bebeklerde Önleyici Bakım",
        "intro": "Bebeğinizin ilk yılında temel önleyici sağlık uygulamaları",
        "topics": [
          "Bebek sağlık kontrolü takvimi",
          "Takip edilmesi gereken gelişim aşamaları",
          "Güvenli uyku uygulamaları",
          "Beslenme ve emzirme",
          "Aşı takvimi"
        ]
      },
      "childDevelopment": {
        "title": "Çocuk Gelişimi ve Evreler",
        "intro": "Sağlıklı büyüme ve gelişimi anlamak",
        "topics": [
          "Fiziksel gelişim aşamaları",
          "Sosyal ve duygusal gelişim",
          "Dil gelişimi",
          "Bilişsel dönüm noktaları",
          "Doktorunuza ne zaman danışmalısınız?"
        ]
      },
      "nutrition": {
        "title": "Beslenme ve Sağlıklı Büyüme",
        "intro": "En baştan sağlıklı yeme alışkanlıkları oluşturmak",
        "topics": [
          "Yaşa uygun beslenme",
          "Sağlıklı atıştırmalık fikirleri",
          "Yemek seçen çocuklarla başa çıkma",
          "Temel gıda güvenliği",
          "Sıvı tüketimi rehberi"
        ]
      },
      "safety": {
        "title": "Güvenlik ve Yaralanmaları Önleme",
        "intro": "Aileniz için güvenli bir ortam oluşturun",
        "topics": [
          "Ev güvenliği kontrol listesi",
          "Oto koltuğu güvenliği",
          "Su güvenliği",
          "Zehirlenmeleri önleme",
          "Acil durumlara hazırlık"
        ]
      }
    }
  }
};
